/* eslint-disable no-plusplus */
/* eslint-disable no-useless-return */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-else-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  TextField,
  Typography,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Checkbox,
  Autocomplete,
  Tooltip,
} from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import moment from 'moment';
import numeral from 'numeral';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState, useLayoutEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import AddIcon from '@mui/icons-material/Add';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import AddTaskIcon from '@mui/icons-material/AddTask';
import InfoIcon from '@mui/icons-material/Info';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Container } from 'reactstrap';
import imagepreview from '../../../media/upload.png';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import cardImg from '../../../media/Images/popUpImg1.jpg';
import TermsAndCondition from '../../Others/TermsAndCondition';
import NoimageFound from '../../../media/noimage.jpg';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const shipMentTypesforIN = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
];

const shipMentTypesforUK = [
  { label: 'Air Cargo - Srilanka', value: 'ACSL' },
  { label: 'Air Cargo - India', value: 'ACI' },
  { label: 'Sea Cargo - Srilanka', value: 'SCSL' },
];

const DocTypes = [
  { label: 'Document', value: 'Document' },
  { label: 'NonDocument', value: 'NonDocument' },
];

const pickupTypes = [
  { label: 'Collection', value: 'C' },
  { label: 'Drop', value: 'D' },
];

const DimensionType = [
  { label: 'CM', value: 'CM' },
  { label: 'Inch', value: 'Inch' },
];

const BoxType = [
  { label: 'Standard', value: 'Standard' },
  { label: 'Custom', value: 'Custom' },
];

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
  { id: 9, name: 'NIC' },
  { id: 10, name: 'Residence Permit' },
];

const PreviewForCargoOrderApproval = ({ setDialogOpenState, orderDetails, getAllData }) => {
  const Type = 'Edit';
  const EditId = orderDetails.orderid;
  const configuration = {
    headers: {
      Country: sessionStorage.getItem('Origin'),
    },
  };
  const resetStates = {
    // indital data
    shipMentType: 'ACSL',
    docType: 'NonDocument',
    branch: '',
    NofoBoxes: '',
    salesPerson: [],
    // sender details
    senderName: '',
    senderAddr1: '',
    senderAddr2: '',
    senderAddr3: '',
    senderCity: '',
    senderState: '',
    senderCountry: '',
    senderPincode: '',
    senderPhone: '',
    senderEmail: '',
    // receiver details
    receiverName: '',
    receiverAddr1: '',
    receiverAddr2: '',
    receiverAddr3: '',
    receiverCity: '',
    receiverState: '',
    receiverCountry: '',
    receiverPincode: '',
    receiverPhone: '',
    receiverEmail: '',
    // collection details
    pickUpType: '',
    // collectionDate: '',
    acceptTerms: false,
    senderAlterPhone: '',
    receiverAlterPhone: '',
    receiverId: '',
    idCardType: '',
    IdCardNo: '',
    IDcardFile: null,
    RecidCardType: '',
    RecIdCardNo: '',
    RecIDcardFile: null,
    source: 'Export',
    shipper: '',
    nic: '',
  };
  const classes = useStyles();
  const navigate = useNavigate();
  const { openSnackBar, closeSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const Origin = sessionStorage.getItem('Origin');
  const [initialValue, setInitialValue] = useState(resetStates);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [senderStateList, setSenderStateList] = useState([]);
  const [receiverStateList, setReceiverStateList] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreviews, setImagePreviews] = useState({});
  const [editID, setEditID] = useState('');
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [boxToDelete, setBoxToDelete] = useState(null);

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];
  const [boxCount, setBoxCount] = useState(sessionStorage.getItem('Origin') === 'UK' ? 1 : 0);
  const [boxDetails, setBoxDetails] = useState([]);
  const [expanded, setExpanded] = useState({});
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);
  const [termsConditions, setTermsConditions] = useState([]);
  const [bookingStarted, setBookingStarted] = useState(false);
  const [goodsList, setGoodsList] = useState([]);
  const [boxSizeList, setboxSizeList] = useState([]);
  const [uomList, setUOMList] = useState([]);
  // const [defaultUOMList, setDefaultUOMList] = useState([]);
  const [headerData, setHeaderData] = useState([]);
  const [sameAsSender, setsameAsSender] = useState(false);
  const [receiverCountryErr, setreceiverCountryErr] = useState(false);
  const [senderCountryErr, setsenderCountryErr] = useState(false);
  const [receiverCountryId, setReceiverCountryId] = useState();
  const [shipperPriceData, setShipperPriceData] = useState([]);
  const [cardToggle, setCardToggle] = useState(false);
  const [seOrderCancelReq, setseOrderCancelReq] = useState('');
  const [IsCancel, setIsCancel] = useState('');
  const [primarySales, setPrimarySales] = useState({});
  const [otherBranchBool, setOtherBranchBool] = useState(false);
  const [orderApproval, setOrderApproval] = useState(false);
  const [changeContent, setChangeContent] = useState('');
  const [openConfirmDialog1, setOpenConfirmDialog1] = useState(false);
  const [submitConfirmation, setSubmitConfirmation] = useState(false);
  const [senderSecondaryCountryId, setSenderSecondaryCountryId] = useState();
  const boxDetailsTempRef = useRef(null); // Holds the initial data // Temporary State to send mail in edit mode
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const contentRef = useRef(null);
  const salesPersonTempRef = useRef(null);
  const [reason, setReason] = useState('');
  const [error, setError] = useState('');
  const [cancelRemarksText, setCancelRemarksText] = useState('');
  const [receiverList, setReceiverList] = useState([]);
  const [senderImageFile, setSenderImageFile] = useState(null);
  const [receiverImageFile, setReceiverImageFile] = useState(null);
  const [senderImagePreview, setSenderImagePreview] = useState('');
  const [receiverImagePreview, setReceiverImagePreview] = useState('');
  const [previewTarget, setPreviewTarget] = useState(null);
  const [shipperId, setShipperId] = useState(0);
  const [hideUom, setHideUom] = useState(true);
  const [openDialogPreview, setOpenDialogPreview] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [isDraft, setIsDraft] = useState(true);
  const [openDeleteDialogCargo, setOpenDeleteDialogCargo] = useState(false);
  const [deleteCargoId, setDeleteCargoId] = useState(null);
  const [isMinimized, setIsMinimized] = useState(false);
  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);
  const [tc, setTC] = useState(false);
  const fieldRefs = useRef({});
  const [boxLoadEnabled, setBoxLoadEnabled] = useState({});
  const [showIdCardChangeDialog, setShowIdCardChangeDialog] = useState({
    sender: false,
    receiver: false,
  });
  const [pendingIdCardChanges, setPendingIdCardChanges] = useState({
    sender: null,
    receiver: null,
  });
  const [sendPreviewBtn, setSendPreviewBtn] = useState(true);
  const [receivPreviewBtn, setReceivPreviewBtn] = useState(true);

  const handleValidationFlow = async (values, validateForm) => {
    // 1. Validate form using properly accessed values
    const errors = await validateForm(values);
    const errorPriority = [
      'senderName',
      'senderPhone',
      'senderEmail',
      'senderAddr1',
      'senderCity',
      'senderPincode',
      'receiverName',
      'receiverPhone',
      'receiverAddr1',
      'receiverCity',
      'receiverPincode',
      'branch',
      'acceptTerms',
      'idCardType',
      'RecidCardType',
      'senderImage',
      'receiverImage',
      'IdCardNo',
      'RecIdCardNo',
    ];

    // Reorder errors according to priority
    const orderedErrors = {};
    errorPriority.forEach((field) => {
      if (errors[field]) {
        orderedErrors[field] = errors[field];
      }
    });

    // 2. Handle error cases
    if (Object.keys(orderedErrors).length > 0) {
      console.log(orderedErrors, 'orderedErrors');
      const firstErrorKey = Object.keys(orderedErrors)[0];
      console.log(orderedErrors[firstErrorKey], 'orderedErrors');
      setTimeout(() => {
        openSnackBar(orderedErrors[firstErrorKey], 'error');
      }, 100);
      fieldRefs.current[firstErrorKey]?.focus();
      return;
    }

    // 3. Your existing special validations
    if (!validateBoxGoodsDetails(boxDetails)) return;

    if (Number(values.senderCountry) !== Number(senderSecondaryCountryId) && sameAsSender === true) {
      setOpenConfirmDialog1(true);
      const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
      const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderSecondaryCountryId));
      setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
          and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
      return;
    }

    setSubmitConfirmation(true);
  };

  // Handle input change
  const handleReasonChange = (event) => {
    setReason(event.target.value);
    setError(''); // Clear error when user starts typing
  };

  const getIdCardNameById = (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => Number(card.id) === Number(id));
    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  const handleIdFileChange = (event, target) => {
    const file = event.target.files[0];
    if (!file) return;

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      openSnackBar('File size exceeds the maximum allowed size (5 MB).', 'error');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      openSnackBar('Invalid file type. Allowed types are JPEG and PNG.', 'error');
      return;
    }

    // Update the selected file and preview depending on whether it's sender or receiver
    if (target === 'sender') {
      setSenderImageFile(file);
      setSenderImagePreview(URL.createObjectURL(file));
    } else if (target === 'receiver') {
      setReceiverImageFile(file);
      setReceiverImagePreview(URL.createObjectURL(file));
    } else {
      // fallback: keep old single-file behavior
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleScroll = () => {
    const content = contentRef.current;
    if (content) {
      const isAtBottom = Math.abs(content.scrollHeight - content.scrollTop - content.clientHeight) <= 1;
      setIsScrolledToBottom(isAtBottom);
    }
  };

  async function GetEditData(id) {
    showLoading();
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: sessionStorage.getItem('country'),
        },
      };
      const response = await axios.get(`Transactions/Cargo/GetAllCargo/${id}`, config);
      setBookingStarted(true);
      const CargoHeader = response.data.CargoHeader[0];
      const { CargoDetails } = response.data;
      const salesPerson = response.data.salesPerson[0];
      setHeaderData(response.data.CargoHeader[0]);
      getSenderState(CargoHeader.SENDER_COUNTRY);
      getReceiverState(CargoHeader.RECEIVER_COUNTRY);
      setsameAsSender(CargoHeader.sameAs_Sender === 'Y');
      setReceiverCountryId(CargoHeader.RECEIVER_COUNTRY);
      setseOrderCancelReq(CargoHeader.SE_OrderCancelReq);
      setIsCancel(CargoHeader.IsCancel);
      console.log('1');
      setOtherBranchBool((CargoHeader.BRANCH_NAME?.trim()?.toLowerCase() || '') === 'other');
      console.log('2');
      setOrderApproval(CargoHeader.APPROVAL === 'Y');
      setSenderSecondaryCountryId(CargoHeader.SENDERSec_COUNTRY);
      setIsDraft(CargoHeader.IsDraft === 'Y' ? true : false);
      setTC(Number(CargoHeader.TERMS_ID) === 2 ? true : false);
      setCancelRemarksText(CargoHeader.CancelRemarks);
      if (CargoHeader.Customer_OrderCancel === 'Y') {
        openSnackBar('Booking has been cancelled by customer.');
      }
      if (sessionStorage.getItem('userRole') === 'Admin') {
        if (CargoHeader.SE_OrderCancelReq === 'R') {
          openSnackBar(
            'Sales Executive has requested to cancel the order. Please review and take the necessary action.'
          );
        }
        if ((CargoHeader.BRANCH_NAME?.trim()?.toLowerCase() || '') === 'other') {
          openSnackBar('A customer placed an order in the Other branch. kindly change that');
        }
      }
      if (
        sessionStorage.getItem('userRole') === 'Sales' &&
        (CargoHeader.BRANCH_NAME?.trim()?.toLowerCase() || '') === 'other'
      ) {
        openSnackBar('A customer placed an order in the Other branch. kindly contact admin person to change.');
      }
      setPrimarySales({ Name: salesPerson.PrimaryUser_Name, Id: salesPerson.PrimaryUser_Id });
      setCardToggle(true);
      salesPersonTempRef.current = salesPerson.salesPersonId;
      const updatedValues = {
        ...resetStates,
        shipMentType: CargoHeader.SHIPMENT_TYPE || resetStates.shipMentType,
        docType: CargoHeader.DOC_TYPE || resetStates.docType,
        branch: Number(CargoHeader.BRANCH_ID),
        // (CargoHeader.BRANCH_NAME?.trim()?.toLowerCase() || '') === 'other' ? '' : (Number(CargoHeader.BRANCH_ID) !== 0 ? CargoHeader.BRANCH_ID : resetStates.branch),
        NofoBoxes: CargoHeader.NO_OF_BOXES || resetStates.NofoBoxes,
        salesPerson:
          { salesPersonName: salesPerson.salesPersonName, salesPersonId: salesPerson.salesPersonId } ||
          resetStates.salesPerson,
        senderName: CargoHeader.SENDER_NAME || resetStates.senderName,
        senderAddr1: CargoHeader.SENDER_ADDRESS1 || resetStates.senderAddr1,
        senderAddr2: CargoHeader.SENDER_ADDRESS2 || resetStates.senderAddr2,
        senderAddr3: CargoHeader.SENDER_ADDRESS3 || resetStates.senderAddr3,
        senderCity: CargoHeader.SENDER_CITY || resetStates.senderCity,
        senderState: CargoHeader.SENDER_STATE || resetStates.senderState,
        senderCountry: CargoHeader.SENDER_COUNTRY || resetStates.senderCountry,
        senderPincode: CargoHeader.SENDER_PINCODE || resetStates.senderPincode,
        senderPhone: CargoHeader.SENDER_CONTACTNO || resetStates.senderPhone,
        senderEmail: CargoHeader.SENDER_EMAILID || resetStates.senderEmail,
        receiverName: CargoHeader.RECEIVER_NAME || resetStates.receiverName,
        receiverAddr1: CargoHeader.RECEIVER_ADDRESS1 || resetStates.receiverAddr1,
        receiverAddr2: CargoHeader.RECEIVER_ADDRESS2 || resetStates.receiverAddr2,
        receiverAddr3: CargoHeader.RECEIVER_ADDRESS3 || resetStates.receiverAddr3,
        receiverCity: CargoHeader.RECEIVER_CITY || resetStates.receiverCity,
        receiverState: CargoHeader.RECEIVER_STATE || resetStates.receiverState,
        receiverCountry: CargoHeader.RECEIVER_COUNTRY || resetStates.receiverCountry,
        receiverPincode: CargoHeader.RECEIVER_PINCODE || resetStates.receiverPincode,
        receiverPhone: CargoHeader.RECEIVER_CONTACTNO || resetStates.receiverPhone,
        receiverEmail: CargoHeader.RECEIVER_EMAILID || resetStates.receiverEmail,
        pickUpType: CargoHeader.COLLECTION || resetStates.pickUpType,
        // collectionDate: courierHeader.COLLECTION_DATE || resetStates.collectionDate,
        acceptTerms: Number(CargoHeader.TERMS_ID) === 2 ? true : false, // Default to true as per your earlier example
        senderAlterPhone: CargoHeader.SENDER_ALTERCONTACTNO || resetStates.senderAlterPhone,
        receiverAlterPhone: CargoHeader.RECEIVER_ALTERCONTACTNO || resetStates.receiverAlterPhone,
        idCardType: CargoHeader.SENDER_IDCARD_TYPE || resetStates.idCardType,
        IdCardNo: CargoHeader.SENDER_IDCARD_NO || resetStates.IdCardNo,
        RecidCardType: CargoHeader.RECEIVER_IDCARD_TYPE || resetStates.RecidCardType,
        RecIdCardNo: CargoHeader.RECEIVER_IDCARD_NO || resetStates.RecIdCardNo,
        source: CargoHeader.SOURCE || resetStates.source,
        shipper: CargoHeader.ShipperLinerName || resetStates.shipper,
        nic: CargoHeader.Nic_No || resetStates.nic,
      };
      setInitialValue(updatedValues);
      setBoxDetails(CargoDetails);
      boxDetailsTempRef.current = JSON.parse(JSON.stringify(CargoDetails));

      const buildImageUrl = (imgPath) => {
        if (!imgPath) return '';
        if (imgPath.startsWith('http') || imgPath.startsWith('//')) {
          return imgPath.includes('?') ? `${imgPath}&v=${Date.now()}` : `${imgPath}?v=${Date.now()}`;
        }
        const origin = sessionStorage.getItem('Origin');
        const base =
          origin === 'IN'
            ? axios.defaults.inImageURL
            : origin === 'UK'
            ? axios.defaults.ukImageURL
            : axios.defaults.slImageURL;
        const url = `${base}/${imgPath}`;
        return url.includes('?') ? `${url}&v=${Date.now()}` : `${url}?v=${Date.now()}`;
      };
      const senderImg = `CG_FMT${CargoHeader.SENDER_IDCARD_NO}-${getIdCardNameById(
        CargoHeader.SENDER_IDCARD_TYPE
      )}.jpg`;
      const receiverImg = `CG_BMT${CargoHeader.RECEIVER_IDCARD_NO}-${getIdCardNameById(
        CargoHeader.RECEIVER_IDCARD_TYPE
      )}.jpg`;

      setSenderImagePreview(buildImageUrl(senderImg));
      setReceiverImagePreview(buildImageUrl(receiverImg));

      setSenderImageFile(senderImg || null);
      setReceiverImageFile(receiverImg || null);
      setShipperId(CargoHeader.SHIPPER_LINER_ID || 0);
      // GetShipperPrice(CargoDetails, CargoHeader.RECEIVER_COUNTRY);
      // GetShipperPrice1(null, CargoHeader.RECEIVER_COUNTRY, null, CargoDetails, true);
      const initialBoxLoadEnabled = {};
      CargoDetails.forEach((box, index) => {
        initialBoxLoadEnabled[index] = !box.goods || box.goods.length === 0;
      });
      setBoxLoadEnabled(initialBoxLoadEnabled);
      GetNewShipperPrice(CargoHeader.RECEIVER_COUNTRY, CargoDetails);
      GetReceiverList(CargoHeader.CUSTOMER_ID);
    } catch (e) {
      // openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const { data } = response;
      // setBranchList(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
      setBranchList(data.filter((i) => i.webBranch !== 'N'));
    } catch (e) {
      // openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };
  const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };
  const InsertGoodsMst = async () => {
    try {
      if (goodsdescription.length !== 0) {
        const res = await axios.post('/Master/goods/InsertNewGoods', {
          GoodsName: goodsdescription,
          Price: rate,
          HSCode: hsnCodes,
          Active: active ? 'Y' : 'N',
          CreatedBy: sessionStorage.getItem('UserId'),
        });

        if (res.status === 200) {
          openSnackBar('Added Successfully!', 'success');
          GetGoodsList(); // Fetch updated goods list
          setDialogOpen1(false); // Close the dialog
          setgoodsdescription(''); // Reset fields
          sethsnCodes('');
          setrate('');
          setactive(true);
        }
      } else {
        if (goodsdescription.length === 0) {
          setgoodsdescriptionErr(true);
        }
        setTimeout(() => {
          setgoodsdescriptionErr(false);
        }, 1000);
      }
    } catch (e) {
      const errorMessage = e.response?.data;

      if (errorMessage && errorMessage.includes('GoodsName Already Exists')) {
        openSnackBar('GoodsDescription Already Exists', 'error');
      } else {
        openSnackBar(errorMessage || 'Something Went Wrong. Try Again!', 'error');
      }
    }
  };

  const getSenderState = async (countryid) => {
    try {
      // if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      if (res) {
        setSenderStateList(res.data);
      }
    } catch (err) {
      console.log(err.message);
      setSenderStateList([]);
    }
  };

  const getReceiverState = async (countryid) => {
    try {
      // if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      if (res) {
        setReceiverStateList(res.data);
      }
    } catch (err) {
      console.log(err.message);
      setReceiverStateList([]);
    }
  };

  const getCountryName = (countryid) => {
    const countryObj = countryList.find((obj) => obj.CountryId === countryid);
    if (countryObj) {
      return countryObj.CountryName;
    } else {
      return null;
    }
  };

  const GetGoodsList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetGoodsHelp');
      setGoodsList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetUOMList = async () => {
    try {
      const res = await axios.get('/Transactions/Courier/GetUOMHelp');
      setUOMList(res.data);
      // const result = await axios.get('/Transactions/Courier/GetDefaultUOMHelp');
      // setDefaultUOMList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetTermsAndCondition() {
    try {
      showLoading();
      const response = await axios.get('signup/GetTermsAndCondition/11');
      setTermsConditions(response.data);
    } catch (e) {
      // openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const [salesPersons, setSalesPersons] = useState([]);

  const GetSalesExecutives = async (origin) => {
    try {
      const res = await axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive', {
        headers: {
          Country: origin,
        },
      });
      setSalesPersons(res.data);
    } catch (err) {
      setSalesPersons([]);
    }
  };

  const GetParameter = async () => {
    try {
      const res = await axios.get(`/master/parameter/GetParameters/${sessionStorage.getItem('CompanyId')}`);
      const hide = res.data[0].IsUOMHidden_Web === 'N';
      setHideUom(hide);
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    GetCountryList();
    GetBranchList(sessionStorage.getItem('Origin'));
    GetTermsAndCondition();
    GetGoodsList();
    GetBoxSizeHelp();
    GetUOMList();
    GetSalesExecutives(sessionStorage.getItem('country'));
    GetParameter();
  }, []);

  useLayoutEffect(() => {
    if (Type === 'Edit') {
      GetEditData(EditId);
    }
  }, [Type, EditId]);

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          // Initial data validation
          docType: Yup.string().required('Select Type of Document'),
          NofoBoxes: Yup.number()
            .required('No of boxes is required')
            .min(1, 'Must be at least 1 box')
            .max(10, 'No more than 10 boxes allowed'),
          senderCountry: Yup.string().required('Country is required'),
          receiverCountry: Yup.string().required('Country is required'),
          senderImage: Yup.mixed().test('sender-image-required', 'ID card image is required', () => {
            const hasIdCard = values?.idCardType && values.idCardType !== '0';
            return !hasIdCard || Boolean(senderImageFile || senderImagePreview);
          }),
          receiverImage: Yup.mixed().test('receiver-image-required', 'ID card image is required', () => {
            const hasIdCard = values?.RecidCardType && values.RecidCardType !== '0';
            return !hasIdCard || Boolean(receiverImageFile || receiverImagePreview);
          }),

          // Sender details validation
          ...(bookingStarted && {
            branch: Yup.string().required('Branch is required'),
            idCardType: Yup.string()
              .required('ID Card Type is required')
              .test('sender-id-card-type-selected', 'Select Sender ID Card Type', (value) => Number(value) > 0),
            RecidCardType: Yup.string()
              .required('ID Card Type is required')
              .test('receiver-id-card-type-selected', 'Select Receiver ID Card Type', (value) => Number(value) > 0),
            senderName: Yup.string().required('Sender name is required'),
            senderAddr1: Yup.string().required('Address line 1 is required'),
            senderAddr2: Yup.string(), // Optional
            senderAddr3: Yup.string(), // Optional
            senderCity: Yup.string().required('City is required'),
            senderPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            senderPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            senderEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Receiver details validation
            receiverName: Yup.string().required('Receiver name is required'),
            receiverAddr1: Yup.string().required('Address line 1 is required'),
            receiverAddr2: Yup.string(), // Optional
            receiverAddr3: Yup.string(), // Optional
            receiverCity: Yup.string().required('City is required'),
            receiverPincode: Yup.string()
              .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
              .max(15, 'Pincode cannot exceed 15 characters')
              .required('Pincode is required'),
            receiverPhone: Yup.string()
              .matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits')
              .required('Phone number is required'),
            // receiverEmail: Yup.string().email('Enter a valid email address').required('Email address is required'),

            // Collection details validation
            // pickUpType: Yup.string().required('Pick-up type is required'),
            acceptTerms: Yup.boolean()
              .oneOf([true], 'You must agree to the terms and conditions')
              .required('You must agree to the terms'),
            senderAlterPhone: Yup.string().matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
            receiverAlterPhone: Yup.string().matches(/^\d{9,15}$/, 'Phone number must be between 9 and 15 digits'),
            IdCardNo: Yup.string().when('idCardType', {
              is: (val) => val && val !== '0',
              then: (schema) =>
                schema
                  .required('ID Card Number is required')
                  .test('not-all-zeros', 'ID Card Number is required', (value) => {
                    if (!value) return true; // Let required validation handle empty values
                    return !/^0+$/.test(value); // Rejects strings that contain only zeros
                  }),
              otherwise: (schema) => schema.notRequired(),
            }),
            RecIdCardNo: Yup.string().when('RecidCardType', {
              is: (val) => val && val !== '0',
              then: (schema) =>
                schema
                  .required('ID Card Number is required')
                  .test('not-all-zeros', 'ID Card Number is required', (value) => {
                    if (!value) return true; // Let required validation handle empty values
                    return !/^0+$/.test(value); // Rejects strings that contain only zeros
                  }),
              otherwise: (schema) => schema.notRequired(),
            }),
          }),
        })
      ),
    [
      bookingStarted,
      sessionStorage.getItem('Origin'),
      initialValue,
      senderImageFile,
      receiverImageFile,
      senderImagePreview,
      receiverImagePreview,
    ]
  );

  // Box Size Help
  const GetBoxSizeHelp = async () => {
    try {
      const res = await axios.get('/Transactions/Cargo/GetCargoxBoxSizeHelp');
      setboxSizeList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function submitCargoOrder(values, isDraft) {
    const data = {
      OPTYPE: Type === 'Edit' ? 'Edit' : 'New',
      // COURIER_NO: "123456",
      CARGO_ID: Type === 'Edit' ? EditId : 0,
      COMPANY_ID: sessionStorage.getItem('CompanyId'),
      BRANCH_ID: values.branch,
      CUSTOMER_ID: headerData.CUSTOMER_ID,
      SHIPMENT_TYPE: values.shipMentType,
      DOC_TYPE: values.docType,
      NO_OF_BOXES: values.NofoBoxes,
      SALESEXECUTIVES: values.salesPerson
        ? JSON.stringify(values.salesPerson)
        : JSON.stringify({ salesPersonName: '', salesPersonId: 0 }),
      SEreassignId: values.salesPerson ? values.salesPerson.salesPersonId : 0,
      SENDER_NAME: values.senderName,
      SENDER_ADDRESS1: values.senderAddr1,
      SENDER_ADDRESS2: values.senderAddr2,
      SENDER_ADDRESS3: values.senderAddr3,
      SENDER_CITY: values.senderCity,
      SENDER_STATE: values.senderState,
      SENDER_COUNTRY: values.senderCountry,
      SENDER_PINCODE: values.senderPincode,
      SENDER_CONTACTNO: values.senderPhone,
      SENDER_EMAILID: values.senderEmail,
      RECEIVER_NAME: values.receiverName,
      RECEIVER_ADDRESS1: values.receiverAddr1,
      RECEIVER_ADDRESS2: values.receiverAddr2,
      RECEIVER_ADDRESS3: values.receiverAddr3,
      RECEIVER_CITY: values.receiverCity,
      RECEIVER_STATE: values.receiverState,
      RECEIVER_COUNTRY: values.receiverCountry,
      RECEIVER_PINCODE: values.receiverPincode,
      RECEIVER_CONTACTNO: values.receiverPhone,
      RECEIVER_EMAILID: values.receiverEmail,
      COLLECTION: values.pickUpType,
      COLLECTIONDATE: new Date('1900-01-01').toISOString(),
      TERMSID: tc ? 2 : 0,
      CREATEDBY: 0,
      CREATEDON: new Date().toISOString(),
      MODIFIEDBY: sessionStorage.getItem('UserId'),
      MODIFIEDON: new Date().toISOString(),
      APPROVAL: isDraft === 'Y' ? 'N' : 'Y',
      APPROVEDBY: sessionStorage.getItem('UserId'),
      APPROVEDON: new Date().toISOString(),
      sameAs_Sender: sameAsSender ? 'Y' : 'N',
      SE_OrderCancelReq: 'N',
      SENDER_ALTERCONTACTNO: values.senderAlterPhone,
      RECEIVER_ALTERCONTACTNO: values.receiverAlterPhone,
      SENDER_IDCARD_TYPE: values.idCardType || '',
      SENDER_IDCARD_NO: values.IdCardNo || '',
      RECEIVER_IDCARD_TYPE: values.RecidCardType || '',
      RECEIVER_IDCARD_NO: values.RecIdCardNo || '',
      SENDER_IDCARD_NAME: getIdCardNameById(values.idCardType) || '',
      RECEIVER_IDCARD_NAME: getIdCardNameById(values.RecidCardType) || '',
      SOURCE: values.source || 'Export',
      ShipperLinerName: values.shipper || '',
      SHIPPER_LINER_ID: shipperId || 0,
      IsDraft: isDraft,
      SENDER_IDCARD_IMAGE: senderImageFile,
      RECEIVER_IDCARD_IMAGE: receiverImageFile,
      NIC: values.nic,
    };

    const InsertCargoDtl = boxDetails.map((box, boxIndex) => ({
      OPTYPE: 'New',
      BOX_SELECT: box.BoxType,
      BOX_TYPEID: box.BOXTYPEID,
      BOX_TYPE: box.BoxSize,
      BoxNameType: box.BoxType === 'Custom' ? `${box.length} X ${box.width} X ${box.height}` : box.BoxNameType || '',
      BOXSIZEID: box.BOXSIZEID || 0,
      BOXES: box.boxNo, // Total number of boxes
      CARTON_L: box.length || 0,
      CARTON_W: box.width || 0,
      CARTON_H: box.height || 0,
      CUBIC_WEIGHT: box.cubicWeight || '0',
      DIMENSION: box.dimensionType,
      GROSS_WEIGHT: box.grossWeight || '0',
      NO_OF_ITEMS: box.noOfItems,
      RatePer: box.RatePer,
      Rate: box.Rate || 0,
      Duty: box.Duty || 0,
      Profit: box.Profit || 0,
      SINO: (boxIndex + 1).toString(),
      InsertCargoGoodsDtl: box.goods.map((good, goodIndex) => {
        const isValidImage =
          (typeof good.image === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(good.image) && !/^Doc_/i.test(good.image)) ||
          (typeof good.image === 'object' && good.image instanceof Blob);

        return {
          GOODS_ID: good.GoodsId,
          GOODS_Name: good.goodsName,
          UOM_ID: good.UOM_Id,
          QUANTITY: good.quantity,
          RATE: good.rate === '' ? 0 : good.rate,
          VALUE: good.value,
          BOX: (boxIndex + 1).toString(),
          ITEM_IMAGE: good.image ? good.image : '',
          ITEM_IMG: isValidImage ? 'I' : '',
          NEW_ITEM: good.newGoods || 'N',
          APPROVAL: good.APPROVAL,
          APPROVEDBY: sessionStorage.getItem('UserId'),
          APPROVEDON: new Date().toISOString(),
          SINO: (goodIndex + 1).toString(),
        };
      }),
    }));

    const mergedData = {
      ...data,
      InsertCargoDtl,
    };

    // Add image files if they exist
    if (senderImageFile instanceof File) {
      mergedData.SENDER_IDCARD_IMAGE = senderImageFile;
    }
    if (receiverImageFile instanceof File) {
      mergedData.RECEIVER_IDCARD_IMAGE = receiverImageFile;
    }

    const convertToFormData = (obj, form = new FormData(), parentKey = '') => {
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          const value = obj[key];
          const newKey = parentKey ? `${parentKey}[${key}]` : key;

          if (Array.isArray(value)) {
            value.forEach((item, index) => {
              convertToFormData(item, form, `${newKey}[${index}]`);
            });
          } else if (value instanceof File || value instanceof Blob) {
            // Directly append files
            form.append(newKey, value);
          } else if (value && typeof value === 'object') {
            // Recursively handle nested objects
            convertToFormData(value, form, newKey);
          } else {
            // Append scalar values
            form.append(newKey, value != null ? value : '');
          }
        }
      }
      return form;
    };

    const formData = convertToFormData(mergedData);

    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
      await axios.post('Transactions/Cargo/InsertCargoHdr', formData, config);
      setOpen(false);
      if (!orderApproval) {
        if (isDraft === 'Y') {
          openSnackBar('Booking has been saved as Draft successfully !', 'success');
        } else {
          openSnackBar('Booking has been Approved successfully !', 'success');
          sendloginForOrderApproved(EditId); // Before Approved Mail
        }
      }
      if (orderApproval) {
        if (isDraft === 'Y') {
          openSnackBar('Booking has been saved as Draft successfully !', 'success');
        } else {
          openSnackBar('Booking has been Updated successfully !', 'success');
          if (hasNewEntry(boxDetailsTempRef.current, boxDetails)) sendloginForOrderUpdated(EditId); // After Approved Mail If any changes needed
          const sales = values.salesPerson ? values.salesPerson.salesPersonId : 0;
          if (Number(sales) !== Number(salesPersonTempRef.current) && sessionStorage.getItem('userRole') === 'Admin')
            sendloginForOrderApproved(EditId);
        }
      }
      setDialogOpenState(false);
      getAllData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderApproved(EditId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: sessionStorage.getItem('userRole') === 'Admin' ? 'OrderApproved' : 'OrderApprovedSE',
        customerid: headerData.CUSTOMER_ID,
        Type: 'CA',
        Order_Id: EditId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderUpdated(EditId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: sessionStorage.getItem('userRole') === 'Admin' ? 'OrderUpdatedAdmin' : 'OrderUpdatedSE',
        customerid: headerData.CUSTOMER_ID,
        Type: 'CA',
        Order_Id: EditId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderRejected(EditId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'OrderRejected',
        customerid: headerData.CUSTOMER_ID,
        Type: 'CA',
        Order_Id: EditId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function sendloginForOrderRejectedRequest(EditId) {
    try {
      showLoading();
      const response = await axios.post('notifications/mails/sendMail', {
        MailScenario: 'OrderRejectedRequest',
        customerid: headerData.CUSTOMER_ID,
        Type: 'CA',
        Order_Id: EditId,
      });
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  /*  In this If any changes in the detail it will return true */

  // const hasNewEntry = (prevData, newData) => {
  //   if (!prevData || !newData) return false; // Safety check for null/undefined data

  //   // Check if a new box was added
  //   if (newData.length !== prevData.length) {
  //     return true;
  //   }

  //   // Check if a new goods item was added inside any box
  //   return newData.some((newBox, index) => {
  //     const prevBox = prevData[index];

  //     if (!prevBox) return true; // New box detected

  //     console.log(`Box ${index + 1}: newBox goods count =`, newBox.goods?.length || 0);
  //     console.log(`Box ${index + 1}: prevBox goods count =`, prevBox.goods?.length || 0);

  //     return (newBox.goods?.length || 0) !== (prevBox.goods?.length || 0);
  //   });
  // };

  /*  In this If any New goods added in the detail it will return true */

  const hasNewEntry = (prevData, newData) => {
    if (!prevData || !newData) return false; // Safety check for null/undefined data

    // Check if a new box was added
    if (newData.length !== prevData.length) {
      return true;
    }

    // Check if a new goods item was added inside any box or if any goods has newGoods === 'Y'
    return newData.some((newBox, index) => {
      const prevBox = prevData[index];

      if (!prevBox) return true; // New box detected

      // Check if number of goods changed
      if ((newBox.goods?.length || 0) !== (prevBox.goods?.length || 0)) {
        return true;
      }

      // Check if any goods has newGoods === 'Y'
      return newBox.goods?.some((good) => good.newGoods === 'Y');
    });
  };

  // const handleCountryChangeSender = (e, handleChange) => {
  //   const selectedSenderCountryId = e.target.value;
  //   getSenderState(selectedSenderCountryId);
  //   handleChange(e);
  // };

  const handleCountryChangeSender = (selectedCountry, handleChange) => {
    const selectedSenderCountryId = selectedCountry.CountryId;
    getSenderState(selectedSenderCountryId);
    handleChange({
      target: {
        name: 'senderCountry',
        value: selectedSenderCountryId,
      },
    });
  };

  // const handleCountryChangereceiver = (e, handleChange) => {
  //   const selectedCountryId = e.target.value;
  //   getReceiverState(selectedCountryId);
  //   handleChange(e);
  // };

  const handleCountryChangereceiver = (selectedCountry, handleChange) => {
    const selectedCountryId = selectedCountry.CountryId;
    getReceiverState(selectedCountryId);
    handleChange({
      target: {
        name: 'receiverCountry',
        value: selectedCountryId,
      },
    });
  };

  const handleFileChange = (event, fileType, boxIndex, goodsIndex) => {
    // showLoading();
    if (boxIndex === undefined || goodsIndex === undefined) {
      console.error('Invalid indices: boxIndex or goodsIndex is undefined.');
      return;
    }

    const file = event.target.files[0];
    if (!file) {
      console.error('No file selected.');
      return;
    }

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Generate the preview URL for the image
    const imagePreviewUrl = URL.createObjectURL(file);

    // Update the preview URL in the separate state
    setImagePreviews((prev) => ({
      ...prev,
      [`${boxIndex}-${goodsIndex}`]: imagePreviewUrl, // Store preview URL uniquely for each good
    }));

    // Update only the image property in prevImage
    setPrevImage((prev) => ({
      ...prev,
      goods: {
        ...prev.goods,
        image: imagePreviewUrl, // Reset the image to null
      },
    }));

    // Update the image (file object) in the goods array state as well
    setBoxDetails((prevBoxDetails) => {
      const updatedBoxDetails = [...prevBoxDetails];
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex],
        image: file, // Keep the file object
      };

      return updatedBoxDetails;
    });
    // hideLoading();
  };

  const handleOpenDialogPreview = (target) => {
    setPreviewTarget(target);
    if (target === 'sender') {
      setImagePreview(senderImagePreview);
    } else if (target === 'receiver') {
      setImagePreview(receiverImagePreview);
    }
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
    setImagePreview('');
    setPreviewTarget(null);
  };

  const toggleAccordion = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const toggleAccordionTrue = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: true }));
  };

  const handleBoxCountChange = (value) => {
    showLoading();
    setBoxCount(value);
    const boxes = Array.from({ length: value }, (_, index) => ({
      boxNo: index + 1,
      BoxSize: '',
      BoxType: '',
      length: '',
      width: '',
      height: '',
      dimensionType: 'CM',
      cubicWeight: '',
      grossWeight: '',
      noOfItems: '',
      goods: [],
    }));
    setBoxDetails(boxes);
    const initialLoadState = {};
    for (let i = 0; i < value; i++) {
      initialLoadState[i] = true;
    }
    setBoxLoadEnabled(initialLoadState);
    toggleAccordion(0);
    hideLoading();
  };

  const handleAddBox = async (setFieldValue, values) => {
    // showLoading();
    setInitialValue(values);
    const uom = uomList.find((i) => i.DefaultUOM === 'Y') || { UOM_Id: 0, UOM_Description: '' };
    setBoxDetails((prevDetails) => {
      const newBoxIndex = prevDetails.length;
      const updatedBoxes = [
        ...prevDetails,
        {
          boxNo: prevDetails.length + 1,
          BoxSize: '',
          BoxType: '',
          length: '',
          width: '',
          height: '',
          dimensionType: 'CM',
          cubicWeight: '',
          grossWeight: '',
          noOfItems: 1,
          goods: [
            {
              goodsName: '',
              uom: '',
              UOM_Id: uom.UOM_Id,
              UOM_Description: uom.UOM_Description,
              quantity: '',
              rate: '',
              value: '',
              newGoods: 'N',
              image: null,
            },
          ],
          RatePer: 'CBM',
          Rate: '',
          Duty: '',
          Profit: '',
          ActRate: '',
          actualRate: '',
        },
      ];
      setBoxLoadEnabled((prev) => ({
        ...prev,
        [newBoxIndex]: true,
      }));
      toggleAccordion(newBoxIndex);
      return updatedBoxes; // This ensures a new array is returned
    });
    setTimeout(async () => {
      await new Promise((resolve) => {
        setFieldValue('NofoBoxes', boxDetails.length + 1, () => resolve());
      });
    }, 1000);
    // hideLoading();
  };

  const handleAddGoods = (boxIndex, newFlag) => {
    showLoading();
    const uom = uomList.find((i) => i.DefaultUOM === 'Y') || 0;
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.push({
      goodsName: '',
      uom: '',
      UOM_Id: uom.UOM_Id,
      UOM_Description: uom.UOM_Description,
      quantity: '',
      rate: '',
      value: '',
      newGoods: newFlag,
      image: null,
      // APPROVAL: newFlag === 'Y' ? 'N' : 'Y',
      APPROVAL: newFlag,
    });
    setBoxDetails(updatedBoxDetails);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    hideLoading();
  };

  const handleDeleteGoods = (boxIndex, goodsIndex) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods.splice(goodsIndex, 1);
    updatedBoxDetails[boxIndex].noOfItems = updatedBoxDetails[boxIndex].goods.length;
    setBoxDetails(updatedBoxDetails);
    setImagePreviews((prevPreviews) => {
      const imgPreviews = { ...prevPreviews };
      delete imgPreviews[`${boxIndex}-${goodsIndex}`];
      const updatedPreviews = Object.fromEntries(
        Object.entries(imgPreviews).map(([key, val], i) => {
          const newKey = key.split('-').map(Number);
          if (newKey[1] >= goodsIndex) newKey[1] -= 1;
          return [newKey.join('-'), val];
        })
      );
      return updatedPreviews;
    });
  };

  const handleGoodsChange = (boxIndex, goodsIndex, field, value) => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];
    // updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    if (field === 'goods') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex], // Spread the existing object to keep other fields intact
        GoodsName: value.GoodsName, // Update only the GoodsName or other properties as needed
        GoodsId: value.GoodsId, // Add any additional properties if needed
      };
      // updatedBoxDetails[boxIndex].goods[goodsIndex] = {
      //   ...updatedBoxDetails[boxIndex].goods[goodsIndex], // Keep the existing goods data
      //   UOM_Description: defaultUOMList[0].UOM_Description, // Update UOM
      //   UOM_Id: defaultUOMList[0].UOM_Id, // Update UOM_Id if needed
      // };
    } else if (field === 'uom') {
      updatedBoxDetails[boxIndex].goods[goodsIndex] = {
        ...updatedBoxDetails[boxIndex].goods[goodsIndex], // Keep the existing goods data
        UOM_Description: value.UOM_Description, // Update UOM
        UOM_Id: value.UOM_Id, // Update UOM_Id if needed
      };
    } else {
      // Update only the specific field (e.g., goodsName, quantity, rate)
      updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    }

    // Recalculate the total value of the goods in the box
    if (field === 'quantity' || field === 'rate') {
      const updatedGoods = updatedBoxDetails[boxIndex].goods[goodsIndex];
      updatedGoods.value = parseFloat((updatedGoods.quantity * updatedGoods.rate).toFixed(2));
    }
    setBoxDetails(updatedBoxDetails);
    hideLoading();
  };

  const handleBoxSizeChange = (index, field, value, values) => {
    showLoading();
    const updatedBoxes = [...boxDetails];
    const rawCubicWeight =
      value.DIMENSION === 'CM'
        ? (Number(value.BOXHEIGHT) / 100) * (Number(value.BOXLENGTH) / 100) * (Number(value.BOXWIDTH) / 100)
        : Number(value.BOXHEIGHT) * 0.0254 * (Number(value.BOXLENGTH) * 0.0254) * (Number(value.BOXWIDTH) * 0.0254);
    if (field === 'BoxSize') {
      updatedBoxes[index] = {
        ...updatedBoxes[index],
        length: value.BOXLENGTH,
        width: value.BOXWIDTH,
        height: value.BOXHEIGHT,
        dimensionType: value.DIMENSION,
        grossWeight: '',
        BOXTYPEID: value.BOXTYPEID,
        BoxSize: value.BOXTYPE,
        BoxNameType: value.BOXSIZE,
        BOXSIZEID: value.BOXSIZEID,
        cubicWeight: parseFloat(rawCubicWeight.toFixed(2)),
        BoxType: 'Standard',
        //  - ${value.BOXSIZE}
      };
    }

    setBoxDetails(updatedBoxes);
    // GetShipperPrice(updatedBoxes);
    // GetShipperPrice1(parseFloat(rawCubicWeight.toFixed(2)), null, index);
    GetNewShipperPrice(values.receiverCountry, updatedBoxes);
    hideLoading();
  };

  const handleGoodsChangeY = (boxIndex, goodsIndex, field, value) => {
    const updatedBoxDetails = [...boxDetails];
    updatedBoxDetails[boxIndex].goods[goodsIndex][field] = value;
    setBoxDetails(updatedBoxDetails);
  };

  const cancelOrder = async () => {
    if (seOrderCancelReq !== 'R') {
      if (!reason.trim()) {
        setError('Please provide a reason for cancellation.');
        return;
      }
    }
    showLoading();
    try {
      const res = await axios.put(`/Transactions/Cargo/CancelCargoOrder/${EditId}/${'Y'}/N`, {
        headers: {
          Country: origin,
        },
      });
      const res1 = await axios.put(`/Transactions/SalesControls/SEOrderCancelReq/${'Cargo'}/${EditId}/${'Y'}`, {
        headers: {
          Country: origin,
        },
      });
      sendloginForOrderRejected(EditId);
      if (seOrderCancelReq !== 'R') InsertCustomerTimeLine('CA');
      openSnackBar('Order has been cancelled successfully', 'error');
      setDialogOpenState(false);
      getAllData();
    } catch (err) {
      console.log(err.message);
    }
    hideLoading();
  };

  const RevertOrder = async () => {
    showLoading();
    try {
      const res = await axios.put(`/Transactions/Cargo/CancelCargoOrder/${EditId}/${'N'}/N`, {
        headers: {
          Country: origin,
        },
      });
      const res1 = await axios.put(`/Transactions/SalesControls/SEOrderCancelReq/${'Cargo'}/${EditId}/${'N'}`, {
        headers: {
          Country: origin,
        },
      });
      // sendloginForOrderRejected(EditId);
      openSnackBar('Order has been reverted successfully', 'error');
      sendloginForOrderApproved(EditId);
      setDialogOpenState(false);
      getAllData();
    } catch (err) {
      console.log(err.message);
    }
    hideLoading();
  };

  const SEOrderCancelReq = async () => {
    if (!reason.trim()) {
      setError('Please provide a reason for cancellation.');
      return;
    }
    try {
      const res = await axios.put(`/Transactions/SalesControls/SEOrderCancelReq/${'Cargo'}/${EditId}/${'R'}`, {
        headers: {
          Country: origin,
        },
      });
      setDialogOpenState(false);
      InsertCustomerTimeLine('CA');
      getAllData();
      openSnackBar('Order Cancel Request has been sent successfully', 'error');
      sendloginForOrderRejectedRequest(EditId);
    } catch (err) {
      console.log(err.message);
    }
  };

  async function InsertCustomerTimeLine(OrderType) {
    const newData = {
      Optype: 'New',
      customerId: headerData.CUSTOMER_ID,
      companyId: sessionStorage.getItem('CompanyId'),
      branchId: 0,
      Order_ID: EditId,
      Order_Type: OrderType,
      remarks: reason,
      followup: sessionStorage.getItem('userRole') === 'Admin' ? 'ACL' : 'SCL',
      followupDate: new Date(),
      createdBy: sessionStorage.getItem('UserId'),
      createdOn: new Date(),
    };
    try {
      const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
    } catch (e) {
      console.log(e.response?.data || 'Something Went Wrong try Again !', 'error');
    }
  }

  const getTotalValue = (boxIndex) => {
    const box = boxDetails[boxIndex];
    return parseFloat(box.goods.reduce((total, goods) => Number(total) + Number(goods.value), 0).toFixed(2));
  };

  const resetBooking = () => {
    showLoading();
    setInitialValue(resetStates);
    setBoxCount(0);
    setBoxDetails([]);
    setImagePreviews({});
    setSelectedImageFile('');
    setBookingStarted(false);
    hideLoading();
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setBoxToDelete(boxIndex); // Set the box to be deleted
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  const handleOpenDeleteDialogCargo = () => {
    const idToDelete = EditId || orderDetails?.orderid || null;
    if (!idToDelete) {
      openSnackBar('No order selected to delete', 'warning');
      return;
    }
    if (!isDraft) {
      openSnackBar('Only draft orders can be deleted', 'warning');
      return;
    }
    setDeleteCargoId(idToDelete);
    setOpenDeleteDialogCargo(true);
  };

  const handleCloseDeleteDialogCargo = () => {
    setOpenDeleteDialogCargo(false);
    setDeleteCargoId(null);
  };

  const deleteCargoOrder = async () => {
    if (!deleteCargoId) return;
    try {
      showLoading();
      await axios.delete(`/Transactions/Cargo/DeleteCargo/${deleteCargoId}`, {
        headers: { Country: sessionStorage.getItem('Origin') },
      });
      if (isDraft) {
        openSnackBar('Draft has been deleted successfully!');
      } else {
        openSnackBar('Order has been deleted successfully!');
      }
      await getAllData();
      setDialogOpenState(false);
    } catch (e) {
      openSnackBar('Something went wrong', 'error');
    }
    hideLoading();
    handleCloseDeleteDialogCargo();
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close the confirmation dialog
    setBoxToDelete(null);
  };

  const handleCloseConfirmDialog1 = () => {
    setOpenConfirmDialog1(false); // Close the confirmation dialog
    if (Type !== 'Edit') setsameAsSender(false);
  };

  const [openConfirmCancel, setOpenConfirmCancel] = useState(false);

  const [opencancelreq, setopencancelreq] = useState(false);

  const [openRevertReq, setopenRevertReq] = useState(false);

  const handleOpenConfirmCancel = () => {
    setOpenConfirmCancel(true);
  };

  const handleCloseConfirmClose = () => {
    setOpenConfirmCancel(false);
  };

  // SEOrderCancelReq
  const handleOpenConfirmCancelReq = () => {
    setopencancelreq(true);
  };

  const handleCloseCancelReq = () => {
    setopencancelreq(false);
  };

  // Revertthe Order
  const handleOpenConfirmRevertReq = () => {
    setopenRevertReq(true);
  };

  const handleCloseRevertReq = () => {
    setopenRevertReq(false);
  };

  const handleSamesAsAddress = async (e, setFieldValue, values) => {
    const isChecked = e.target.checked;
    setsameAsSender(isChecked);
    if (isChecked) {
      try {
        // if (!20629) return;
        const res = await axios.get(`/Transactions/Courier/GetSameAsAddress/${headerData.CUSTOMER_ID}`);
        const { data } = res;
        data.forEach(async (senderData) => {
          let state = {};
          if (senderData.CusCountryId && senderData.CusCountryId !== 0) {
            try {
              const res = await axios.get(`/signup/GetAllState/${senderData.CusCountryId}`);
              if (res) {
                state = res.data.find((d) => Number(d.StateId) === Number(senderData.CusstateId));
              }
            } catch {
              console.log('error');
            }
          }
          setSenderSecondaryCountryId(Number(senderData.CusCountryId));
          if (Number(values.senderCountry) === Number(senderData.CusCountryId)) {
            setsenderCountryErr(false);
            setFieldValue('senderName', senderData.CustomerName || '');
            setFieldValue('senderAddr1', senderData.Address1 || '');
            setFieldValue('senderAddr2', senderData.Address2 || '');
            setFieldValue('senderAddr3', senderData.Address3 || '');
            setFieldValue('senderCity', senderData.City || '');
            // setFieldValue('senderState', state.length>0 ?state.StateId || '' : '');
            setFieldValue('senderState', state ? state.StateId : '');
            // setFieldValue('senderCountry', senderData.CusCountryId || '');
            setFieldValue('senderPincode', senderData.Zipcode || '');
            setFieldValue('senderPhone', senderData.Phone || '');
            setFieldValue('senderEmail', senderData.EmailId || '');
            setFieldValue('senderAlterPhone', senderData.AlterPhone || '');
          } else {
            setOpenConfirmDialog1(true);
            const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
            const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderData.CusCountryId));
            setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName}) 
          and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
          }
        });
      } catch (err) {
        console.log(err.message);
      }
    } else {
      setSenderSecondaryCountryId(Number(values.senderCountry));
      // If unchecked, reset the sender data fields
      setFieldValue('senderName', '');
      setFieldValue('senderAddr1', '');
      setFieldValue('senderAddr2', '');
      setFieldValue('senderAddr3', '');
      setFieldValue('senderCity', '');
      setFieldValue('senderState', '');
      // setFieldValue('senderCountry', '');
      setFieldValue('senderPincode', '');
      setFieldValue('senderPhone', '');
      setFieldValue('senderEmail', '');
      setFieldValue('senderAlterPhone', '');
    }
  };

  const handleApprove = (index, goodsIndex) => {
    InsertNewGoods(selectedGoods.goods, hsnCode, index, goodsIndex);
  };

  async function InsertNewGoods(values, hsnCode, index, goodsIndex) {
    try {
      showLoading();
      if (values.GoodsId === '0') {
        const response = await axios.post('master/goods/InsertNewGoods', {
          GoodsName: values.goodsName,
          Active: 1,
          Price: values.rate,
          HSCode: hsnCode,
          CreatedBy: sessionStorage.getItem('UserId'),
          GoodsDtl_Id: values.cargo_GoodsDtl_Id,
          Type: 'Cargo',
        });
        if (response.status === 200) {
          // console.log(response.data[0].GoodsId, 'new GoodsId');
          openSnackBar('New Goods Has Been Approved  Successfully!', 'success');
          handleGoodsChangeY(prevImage.index, prevImage.goodsIndex, 'APPROVAL', 'Y');
          GetGoodsList();
          handleGoodsChangeY(prevImage.index, prevImage.goodsIndex, 'GoodsId', response.data[0].GoodsId);
          hideLoading();
          handleCloseDialog();
        }
      } else {
        handleGoodsChangeY(prevImage.index, prevImage.goodsIndex, 'APPROVAL', 'Y');
        GetGoodsList();
        hideLoading();
        handleCloseDialog();
      }
    } catch (e) {
      // catch (e) {
      //   openSnackBar('Something Went Wrong try Again !', 'error');
      //   hideLoading();
      //   handleCloseDialog();
      // }
      const errorMessage = e.response?.data;

      if (errorMessage && errorMessage.includes('GoodsName Already Exists')) {
        openSnackBar('GoodsName Already Exists', 'error');
      } else {
        openSnackBar(errorMessage || 'Something Went Wrong. Try Again!', 'error');
      }
      hideLoading();
      handleCloseDialog();
    }
  }

  async function UpdateNewGoods(values) {
    try {
      showLoading();
      const response = await axios.put('master/goods/UpdateNewGoods', {
        GoodsDtl_Id: values.goods.cargo_GoodsDtl_Id,
        Type: 'Cargo',
      });
      hideLoading();
      handleCloseDialog();
    } catch (e) {
      hideLoading();
      handleCloseDialog();
    }
  }

  const validateBoxDetails = (box, boxIndex) => {
    const errors = [];

    if (box.length === '' || Number(box.length) === 0) {
      errors.push(`Row ${boxIndex + 1}: Length is required.`);
    }

    if (box.width === '' || Number(box.width) === 0) {
      errors.push(`Row ${boxIndex + 1}: Width is required.`);
    }

    if (box.height === '' || Number(box.height) === 0) {
      errors.push(`Row ${boxIndex + 1}: Height is required.`);
    }

    if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
      errors.push(`Row ${boxIndex + 1}: Gross Weight is required.`);
    }

    if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
      errors.push(`Row ${boxIndex + 1}: No of Items is required.`);
    }

    if (box.boxType === '' || box.boxType === null) {
      errors.push(`Box ${boxIndex + 1}: Select Box is required.`);
    }

    if (box.boxSize === '' || box.boxSize === null) {
      errors.push(`Box ${boxIndex + 1}: Box Size is required.`);
    }

    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Validation failed for this row
    }

    return true; // All validations passed
  };

  const validateBoxGoodsDetails = (boxDetails) => {
    // Validate boxDetails
    const errors = [];

    boxDetails.forEach((box, boxIndex) => {
      if (box.length === '' || Number(box.length) === 0) {
        errors.push(`Box ${boxIndex + 1}: Length is required.`);
      }

      if (box.width === '' || Number(box.width) === 0) {
        errors.push(`Box ${boxIndex + 1}: Width is required.`);
      }

      if (box.height === '' || Number(box.height) === 0) {
        errors.push(`Box ${boxIndex + 1}: Height is required.`);
      }

      if (box.boxType === '' || box.boxType === null) {
        errors.push(`Box ${boxIndex + 1}: Select Box is required.`);
      }

      if (box.boxSize === '' || box.boxSize === null) {
        errors.push(`Box ${boxIndex + 1}: Box Size is required.`);
      }

      if (box.grossWeight === '' || Number(box.grossWeight) === 0) {
        errors.push(`Box ${boxIndex + 1}: Gross Weight is required.`);
      }

      if (box.noOfItems === '' || Number(box.noOfItems) === 0) {
        errors.push(`Box ${boxIndex + 1}: No of Items is required.`);
      }

      if (!box.goods || box.goods.length === 0) {
        errors.push(`Box ${boxIndex + 1}: Enter goods details.`);
      } else {
        // Validate goods within the box
        box.goods.forEach((good, goodIndex) => {
          const goodsNameExists = 'GoodsName' in good;
          const goodsIdExists = 'GoodsId' in good;
          if (
            good.newGoods === 'Y'
              ? good.goodsName === ''
              : (goodsNameExists ? good.GoodsName === '' : false) || !goodsIdExists || Number(good.GoodsId) === 0
          ) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Goods Name is required.`);
          }

          if (good.quantity === '' || Number(good.quantity) === 0) {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Quantity is required.`);
          }
        });
      }
    });

    // Show errors if any
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Stop the process if validation fails
    }

    return true; // All validations passed
  };

  const validateBoxNewGoodsDetails = (boxDetails) => {
    // Validate boxDetails
    const errors = [];

    boxDetails.forEach((box, boxIndex) => {
      // Validate goods within the box
      box.goods.forEach((good, goodIndex) => {
        if (good.newGoods === 'Y' && good.APPROVAL === 'N') {
          if (sessionStorage.getItem('userRole') !== 'Admin') {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Need approval from Admin.`);
          } else {
            errors.push(`Box ${boxIndex + 1}, Good ${goodIndex + 1}: Approval required for this good.`);
          }
        }
      });
    });

    // Show errors if any
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return false; // Stop the process if validation fails
    }

    return true; // All validations passed
  };

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedGoods, setSelectedGoods] = useState(null);
  const [hsnCode, setHsnCode] = useState('');
  const [prevImage, setPrevImage] = useState({});

  const [dialogOpen1, setDialogOpen1] = useState(false);
  const [goodsdescription, setgoodsdescription] = useState('');
  const [rate, setrate] = useState('');
  const [hsnCodes, sethsnCodes] = useState('');
  const [active, setactive] = useState(true);
  const [goodsdescriptionErr, setgoodsdescriptionErr] = useState(false);

  const handleDeleteImage = () => {
    showLoading();
    const updatedBoxDetails = [...boxDetails];

    // Reset the image for the specific goods item
    updatedBoxDetails[prevImage.index].goods[prevImage.goodsIndex] = {
      ...updatedBoxDetails[prevImage.index].goods[prevImage.goodsIndex],
      image: null, // Reset image to null
    };

    // Update the state for boxDetails
    setBoxDetails(updatedBoxDetails);

    // Remove the preview URL for the specific goods item
    setImagePreviews((prevPreviews) => {
      const updatedPreviews = { ...prevPreviews };
      delete updatedPreviews[`${prevImage.index}-${prevImage.goodsIndex}`]; // Remove preview for the deleted image
      return updatedPreviews;
    });

    // Update only the image property in prevImage
    setPrevImage((prev) => ({
      ...prev,
      goods: {
        ...prev.goods,
        image: null, // Reset the image to null
      },
    }));

    hideLoading();
  };

  const handleOpenDialog = (index, goodsIndex, goods) => {
    setDialogOpen(true);
    const hsn = goodsList.find((item) => Number(item.GoodsId) === Number(goods.GoodsId));
    setHsnCode(Number(goods.GoodsId) === 0 ? '' : hsn.HSCode);
    setSelectedGoods({
      index,
      goodsIndex,
      goods,
    });
    setPrevImage({
      index,
      goodsIndex,
      goods,
    });
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setPrevImage({});
    setHsnCode('');
    setSelectedGoods(null);
  };

  const handleOpenDialog1 = () => {
    setDialogOpen1(true);
  };

  const handleCloseDialog1 = () => {
    setDialogOpen1(false);
    setgoodsdescription('');
    setactive('Y');
    sethsnCodes('');
    setrate('');
  };

  // const GetShipperPrice = async (data, receiverCountryids) => {
  //   const result = data.reduce(
  //     (acc, item) => {
  //       const ceilingCubicWeight = Number(item.cubicWeight) || 0;
  //       acc.totalWeight += ceilingCubicWeight;
  //       return acc;
  //     },
  //     { totalWeight: 0 }
  //   );
  //   try {
  //     const res = await axios.get(
  //       `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(
  //         result.totalWeight.toFixed(2)
  //       )}`,
  //       configuration
  //     );
  //     if (res.data.length > 0) {
  //       setShipperPriceData(res.data);
  //       setCardToggle(true);
  //     } else {
  //       setShipperPriceData([]);
  //       setCardToggle(false);
  //     }
  //   } catch (err) {
  //     console.log(err.message);
  //   }
  // };

  // const GetShipperPrice1 = async (val, receiverCountryids, index = null, boxCollection, isEditMode) => {
  //   try {
  //     if (index !== null) {
  //       const res = await axios.get(
  //         `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(val.toFixed(2))}`,
  //         configuration
  //       );

  //       const value = res.data.length > 0 ? res.data[0] : {};

  //       setBoxDetails((prevBoxes) => {
  //         const updatedBoxes = prevBoxes.map((box, i) =>
  //           i === index
  //             ? {
  //               ...box,
  //               RatePer: "CBM",
  //               Rate: value.Rate || 0,
  //               Duty: value.duty || 0,
  //               Profit: value.profit || 0,
  //               ActRate: value.ActRate || 0,
  //               actualRate: value.actualRate || 0,
  //             }
  //             : box
  //         );

  //         const allEmpty = updatedBoxes.every(
  //           value =>
  //             (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //             (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //             (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //         );
  //         const isEmpty = !value.Rate && !value.duty && !value.profit
  //         setCardToggle(!(isEmpty && allEmpty));

  //         return updatedBoxes;
  //       });
  //     } else if (!isEditMode) {
  //       const requests = boxCollection.map(async (box, i) => {
  //         const cubicWeight = Number(box.cubicWeight);

  //         if (Number.isNaN(cubicWeight) || cubicWeight <= 0) {
  //           return box;
  //         }

  //         const res = await axios.get(
  //           `/Transactions/Cargo/GetAllCargoShipperPrice/${receiverCountryids || receiverCountryId}/${Number(cubicWeight.toFixed(2))}`,
  //           configuration
  //         );

  //         const value = res.data.length > 0 ? res.data[0] : {};
  //         return {
  //           ...box,
  //           RatePer: "CBM",
  //           Rate: value.Rate || 0,
  //           Duty: value.duty || 0,
  //           Profit: value.profit || 0,
  //           ActRate: value.ActRate || 0,
  //           actualRate: value.actualRate || 0,
  //         };
  //       });

  //       const updatedBoxes = await Promise.all(requests);
  //       setBoxDetails(updatedBoxes);
  //       // const allEmpty = updatedBoxes.every(box => !box.Rate && !box.Duty && !box.Profit && !box.ActRate && !box.actualRate);
  //       const allEmpty = updatedBoxes.every(
  //         value =>
  //           (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //           (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //           (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //       );
  //       setCardToggle(!allEmpty);
  //     } else if (isEditMode) {
  //       setBoxDetails(boxCollection);
  //       const isEmpty = boxCollection.every(
  //         value =>
  //           (value.Rate === "" || value.Rate === "0" || value.Rate === 0) &&
  //           (value.Duty === "" || value.Duty === "0" || value.Duty === 0) &&
  //           (value.Profit === "" || value.Profit === "0" || value.Profit === 0)
  //       );
  //       setCardToggle(!isEmpty);
  //     }
  //   } catch (err) {
  //     console.error("Error updating box prices:", err);
  //   }
  // };

  // Added by harel on 31-05-2025
  const GetNewShipperPrice = async (receiverCountryids, boxCollection, cusBranchids) => {
    try {
      const boxData = boxCollection || boxDetails;
      const output = boxData.map((box) => ({
        CountryId: receiverCountryids,
        BoxSizeId: parseInt(box.BOXSIZEID, 10),
        CBM: box.cubicWeight,
        BoxType: box.BoxType,
      }));

      const res = await axios.post(
        `/Transactions/Cargo/GetAllCargoNewShipperPrice`,
        {
          output,
        },
        configuration
      );

      if (res.data.output && res.data.output.length > 0) {
        setShipperPriceData(res.data);
        setCardToggle(true);
      } else {
        setShipperPriceData([]);
        setCardToggle(false);
      }
    } catch (err) {
      console.error('Error updating box prices:', err);
      setShipperPriceData([]);
      setCardToggle(false);
    }
  };

  // useEffect(() => {
  //   GetShipperPrice();
  // }, [boxDetails]);

  const startsWithFilter = createFilterOptions({
    matchFrom: 'any', // The Filter Type are start and any
    stringify: (option) => option.GoodsName || '', // Determines the field to filter
  });

  const GetReceiverList = async (cusId) => {
    try {
      const config = {
        headers: {
          Country: sessionStorage.getItem('Origin'),
        },
      };
      const response = await axios.post(
        `/Transactions/Cargo/GetAllCargoReceiverHelp`,
        {
          CustomerId: cusId,
        },
        sessionStorage.getItem('CompanyId'),
        config
      );
      setReceiverList(response.data);
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
  };

  return (
    <>
      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
      <Container maxWidth={'xl'} sx={{ pt: 2 }}>
        <Container component={Paper} elevation={2}>
          <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, p: 2 }}>
            {headerData.IsCancel === 'Y' && headerData.Customer_OrderCancel === 'N' && (
              <Chip
                label={`This Booking was cancelled for this Reason: ${cancelRemarksText}`}
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {sessionStorage.getItem('userRole') === 'Admin' && seOrderCancelReq === 'R' && (
              <Chip
                label={`Sales Executive has requested to cancel the order.\n${
                  cancelRemarksText ? `Reason: ${cancelRemarksText}` : 'Please review and take the necessary action.'
                }`}
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {sessionStorage.getItem('userRole') === 'Sales' && seOrderCancelReq === 'R' && (
              <Chip
                label={`Your request to cancel the order is under review by the Admin. Reason: ${cancelRemarksText}`}
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {sessionStorage.getItem('userRole') === 'Admin' && otherBranchBool && (
              <Chip
                label="A customer placed an order in the Other branch. kindly change that"
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {sessionStorage.getItem('userRole') === 'Sales' && otherBranchBool && (
              <Chip
                label="A customer placed an order in the Other branch. kindly contact admin person to change."
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {headerData.OrderRaised === 'Y' && (
              <Chip
                label="Booking Confirmed can't edit or cancel order"
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            {headerData.Customer_OrderCancel === 'Y' && (
              <Chip
                label={`Booking has been cancelled by customer. Reason: ${cancelRemarksText}`}
                size="small"
                color="warning"
                variant="contained"
                icon={<ReportGmailerrorredIcon />}
                sx={{ mb: 2 }}
              />
            )}
            <Grid container spacing={2} p={1} rowSpacing={2} columnSpacing={1}>
              <Grid item md={1} xs={12}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Order No
                  <br />{' '}
                  <Typography variant="h6" color="#009688">
                    {orderDetails?.orderNo}
                  </Typography>
                </Typography>
              </Grid>

              {headerData.PreBookOrderNo && (
                <Grid item md={2} xs={12}>
                  <Typography variant="subtitle2" color="GrayText" pr={1}>
                    Pre-Booking No
                    <br />{' '}
                    <Typography variant="h6" color="#009688">
                      {headerData.PreBookOrderNo}
                    </Typography>
                  </Typography>
                </Grid>
              )}

              <Grid item md={2} xs={12}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Order Date
                  <br />{' '}
                  <Typography variant="h6" color="#009688">
                    {moment(orderDetails?.orderDate).format('DD-MM-YYYY')}
                  </Typography>
                </Typography>
              </Grid>

              <Grid item md={3} xs={12}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Customer Name
                  <br />{' '}
                  <Typography variant="h6" color="#009688">
                    {orderDetails?.customerName}
                  </Typography>
                </Typography>
              </Grid>

              <Grid item md={2} xs={12}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Shipment Type
                  <br />{' '}
                  <Typography variant="h6" color="#009688">
                    {orderDetails?.shipmentType}
                  </Typography>
                </Typography>
              </Grid>
              <Grid item md={2} xs={12}>
                <Typography variant="subtitle2" color="GrayText" pr={1}>
                  Primary Sales Person
                  <br />{' '}
                  <Typography variant="h6" color="#009688">
                    {primarySales.Name}
                  </Typography>
                </Typography>
              </Grid>
            </Grid>
            <Divider sx={{ my: 2 }} variant="middle">
              <Chip label="Basic Details" size="small" color="primary" variant="outlined" />
            </Divider>
            <Formik
              enableReinitialize={Type === 'Edit'}
              validationSchema={ValidationSchema}
              initialValues={{ ...initialValue, boxDetails }}
              onSubmit={async (values, { resetForm, setErrors, setFieldError }) => {
                await submitCargoOrder({ ...initialValue, ...values }, 'N');
                resetForm();
              }}
            >
              {({
                submitForm,
                touched,
                values,
                errors,
                handleChange,
                handleBlur,
                isSubmitting,
                setFieldTouched,
                validateForm,
                setFieldValue,
                resetForm,
                setErrors,
                setTouched,
              }) => (
                <Form>
                  <Grid container spacing={2} p={1} rowSpacing={3} columnSpacing={4}>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth size="small" required>
                        <InputLabel>Shipment Type</InputLabel>
                        <Select
                          value={values.shipMentType || ''}
                          name="shipMentType"
                          size="small"
                          label="Shipment Type"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={touched.shipMentType && !!errors.shipMentType}
                          disabled={bookingStarted}
                          required
                        >
                          {sessionStorage.getItem('Origin') === 'IN'
                            ? shipMentTypesforIN.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))
                            : shipMentTypesforUK.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                        </Select>
                        {touched.shipMentType && errors.shipMentType && (
                          <Typography
                            variant="caption"
                            color="error"
                            className="shake-helper-text"
                            margin="4px 0 0 14px"
                          >
                            {errors.shipMentType}
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <FormControl fullWidth size="small">
                        <TextField
                          fullWidth
                          size="small"
                          label="Shipper"
                          name="shipper"
                          value={values.shipper || ''}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                        />
                      </FormControl>
                    </Grid>
                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth size="small" required>
                        <Autocomplete
                          options={countryList || []}
                          getOptionLabel={(country) => country.CountryName || ''}
                          renderOption={(props, country) => (
                            <li {...props} key={country.CountryId}>
                              {country.CountryName}
                            </li>
                          )}
                          isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                          value={countryList.find((country) => country.CountryId === values.senderCountry) || null}
                          name="senderCountry"
                          onChange={(event, value) => {
                            if (value) {
                              setsenderCountryErr(false);
                              setFieldValue('senderCountry', value.CountryId);
                              handleCountryChangeSender(value, handleChange);
                            } else {
                              setFieldValue('senderCountry', '');
                            }
                          }}
                          onBlur={() => setFieldTouched('senderCountry', true)}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Sender Country"
                              value={values.senderCountry ? values.senderCountry : ''}
                              helperText={senderCountryErr ? 'Sender Country is required' : ''}
                              FormHelperTextProps={{
                                style: { color: 'red' },
                              }}
                              required
                            />
                          )}
                          noOptionsText="No country available"
                        />
                      </FormControl>
                    </Grid>

                    <Grid item md={5} xs={12}>
                      <FormControl fullWidth size="small" required>
                        <Autocomplete
                          options={countryList || []}
                          getOptionLabel={(country) => country.CountryName || ''}
                          renderOption={(props, country) => (
                            <li {...props} key={country.CountryId}>
                              {country.CountryName}
                            </li>
                          )}
                          isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                          value={countryList.find((country) => country.CountryId === values.receiverCountry) || null}
                          name="receiverCountry"
                          onChange={(event, value) => {
                            if (value) {
                              setreceiverCountryErr(false);
                              setFieldValue('receiverCountry', value.CountryId);
                              setReceiverCountryId(value.CountryId);
                              handleCountryChangereceiver(value, handleChange);
                              // GetShipperPrice(boxDetails);
                              // GetShipperPrice1(null, value.CountryId, null, boxDetails);
                              GetNewShipperPrice(value.CountryId, boxDetails);
                            } else {
                              setFieldValue('receiverCountry', '');
                            }
                          }}
                          onBlur={() => setFieldTouched('receiverCountry', true)}
                          size="small"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Receiver Country"
                              value={values.receiverCountry ? values.receiverCountry : ''}
                              helperText={receiverCountryErr ? 'Receiver Country is required' : ''}
                              FormHelperTextProps={{
                                style: { color: 'red' },
                              }}
                              required
                            />
                          )}
                          noOptionsText="No country available"
                        />
                      </FormControl>
                    </Grid>

                    {/* {values.shipMentType !== 'SCSL' && (
                      <Grid item md={bookingStarted ? 3 : 4} xs={12}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Document Type</InputLabel>
                          <Select
                            value={values.docType || ''}
                            name="docType"
                            size="small"
                            label="Document Type"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.docType && !!errors.docType}
                            disabled={bookingStarted}
                          >
                            {DocTypes.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </Select>
                          {touched.docType && errors.docType && (
                            <Typography
                              variant="caption"
                              color="error"
                              className="shake-helper-text"
                              margin="4px 0 0 14px"
                            >
                              {errors.docType}
                            </Typography>
                          )}
                        </FormControl>
                      </Grid>
                    )} */}

                    <Grid item md={2} xs={12}>
                      <TextField
                        fullWidth
                        size="small"
                        label="No of Boxes"
                        type="text"
                        name="NofoBoxes"
                        disabled={bookingStarted}
                        onBlur={handleBlur}
                        error={touched.NofoBoxes && !!errors.NofoBoxes}
                        helperText={touched.NofoBoxes && errors.NofoBoxes ? errors.NofoBoxes : ''}
                        value={values.NofoBoxes}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        required
                      />
                    </Grid>
                    {/* <Grid item xs={11}>
                      <Autocomplete
                        multiple
                        id="salesperson-select"
                        options={salesPersons.filter(
                          (value) =>
                            Array.isArray(values.salesPerson) &&
                            !values.salesPerson.map((item) => item.salesPersonId).includes(value.salesPersonId)
                        )}
                        // options={salesPersons.filter(
                        //   (value) => !values.salesPerson.map((item) => item.salesPersonId).includes(value.salesPersonId)
                        // )}
                        getOptionLabel={(option) => option.salesPersonName}
                        disableCloseOnSelect
                        value={values.salesPerson}
                        onBlur={handleBlur}
                        onChange={(event, newValue) => {
                          setFieldValue('salesPerson', newValue);
                        }}
                        renderOption={(props, option, { selected }) => <li {...props}>{option.salesPersonName}</li>}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={index}
                              label={option.salesPersonName}
                              {...getTagProps({ index })}
                              size="small" // Control the size of the chip
                              color="primary"
                              variant="outlined"
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label="Sales Persons"
                            error={!!errors.salesPerson && touched.salesPerson}
                          />
                        )}
                        style={{ width: '100%' }}
                      />
                      {touched.salesPerson && errors.salesPerson && (
                        <Typography variant="caption" color="error" margin="4px 0 0 14px">
                          {errors.salesPerson}
                        </Typography>
                      )}
                    </Grid> */}
                    <Grid item md={12} xs={12}>
                      <Autocomplete
                        id="salesperson-select"
                        options={salesPersons.filter(
                          (person) => Number(person.salesPersonId) !== Number(primarySales.Id)
                        )}
                        getOptionLabel={(option) => option.salesPersonName}
                        value={values.salesPerson || null}
                        onBlur={handleBlur}
                        disabled={sessionStorage.getItem('userRole') === 'Sales'}
                        onChange={(event, newValue) => {
                          setFieldValue('salesPerson', newValue);
                        }}
                        renderOption={(props, option) => <li {...props}>{option.salesPersonName}</li>}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            label="Secondary Sales Person"
                            error={!!errors.salesPerson && touched.salesPerson}
                          />
                        )}
                        style={{ width: '100%' }}
                      />
                      {touched.salesPerson && errors.salesPerson && (
                        <Typography variant="caption" color="error" margin="4px 0 0 14px">
                          {errors.salesPerson}
                        </Typography>
                      )}
                    </Grid>
                    {/* <Grid item md={bookingStarted ? 1 : 12} xs={12}>
                      <Stack direction="row" justifyContent="center" sx={{ width: '100%' }}>
                        <Button
                          variant={bookingStarted ? 'outlined' : 'contained'}
                          color={bookingStarted ? 'error' : 'warning'}
                          size={bookingStarted ? 'medium' : 'small'}
                          sx={{ boxShadow: 1 }}
                          type={bookingStarted ? 'button' : 'submit'}
                          onClick={async () => {
                            if (bookingStarted) {
                              resetForm();
                              resetBooking();
                              setErrors({});
                              setTouched({});
                            } else {
                              const formErrors = await validateForm();
                              if (Object.keys(formErrors).length === 0) {
                                handleBoxCountChange(values.NofoBoxes);
                                setBookingStarted(true);
                              }
                            }
                          }}
                          fullWidth={bookingStarted}
                        >
                          {bookingStarted ? 'Reset' : 'Start Booking'}
                        </Button>
                      </Stack>
                    </Grid> */}
                    {bookingStarted && (
                      <>
                        <Grid item md={12} xs={12}>
                          <Divider sx={{ my: 2 }} variant="middle">
                            <Chip label="Shipment Details" size="small" color="info" variant="outlined" />
                          </Divider>
                        </Grid>
                        <Grid item md={12} xs={12}>
                          <Grid container spacing={2} rowSpacing={4} columnSpacing={4} pl={2}>
                            <Grid item xs={12}>
                              <Stack direction="column" alignItems="right" justifyContent="right" spacing={1}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={sameAsSender}
                                      onChange={(event) => {
                                        handleSamesAsAddress(event, setFieldValue, values);
                                      }}
                                      name="sameAsAddress"
                                      color="primary"
                                    />
                                  }
                                  label="Same as Customer"
                                  sx={{
                                    marginTop: 0, // Ensures no extra space above
                                    '& .MuiTypography-root': { fontSize: '0.875rem', margin: 0 }, // Adjusts label styling
                                  }}
                                />
                              </Stack>
                            </Grid>
                            {/* sender details */}
                            <Grid item md={6} xs={12}>
                              <Grid
                                container
                                spacing={2}
                                rowSpacing={2}
                                columnSpacing={2}
                                component={Paper}
                                p={2}
                                pt={0}
                                pl={0}
                                pr={2}
                                elevation={3}
                                sx={{
                                  bgcolor: 'inherit',
                                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                }}
                              >
                                <Grid item md={12} xs={12}>
                                  <Divider sx={{ mb: 0 }} variant="fullWidth">
                                    <Chip label="Sender Details" size="small" variant="outlined" />
                                  </Divider>
                                </Grid>
                                <Grid item md={12} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Name"
                                    type="text"
                                    name="senderName"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderName = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderName && !!errors.senderName}
                                    helperText={touched.senderName && errors.senderName ? errors.senderName : ''}
                                    value={values.senderName}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Contact No"
                                    type="text"
                                    name="senderPhone"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderPhone = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderPhone && !!errors.senderPhone}
                                    helperText={touched.senderPhone && errors.senderPhone ? errors.senderPhone : ''}
                                    value={values.senderPhone}
                                    onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      handleChange({ target: { name: 'senderPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                    }}
                                    // onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="Alternative Contact No"
                                    type="text"
                                    name="senderAlterPhone"
                                    onBlur={handleBlur}
                                    error={touched.senderAlterPhone && !!errors.senderAlterPhone}
                                    helperText={
                                      touched.senderAlterPhone && errors.senderAlterPhone ? errors.senderAlterPhone : ''
                                    }
                                    value={values.senderAlterPhone}
                                    onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      handleChange({ target: { name: 'senderAlterPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                    }}
                                    // onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Email"
                                    type="email"
                                    name="senderEmail"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderEmail = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderEmail && !!errors.senderEmail}
                                    helperText={touched.senderEmail && errors.senderEmail ? errors.senderEmail : ''}
                                    value={values.senderEmail}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    required
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 1"
                                    name="senderAddr1"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderAddr1 = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderAddr1 && !!errors.senderAddr1}
                                    helperText={touched.senderAddr1 && errors.senderAddr1 ? errors.senderAddr1 : ''}
                                    value={values.senderAddr1}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 2"
                                    name="senderAddr2"
                                    onBlur={handleBlur}
                                    error={touched.senderAddr2 && !!errors.senderAddr2}
                                    helperText={touched.senderAddr2 && errors.senderAddr2 ? errors.senderAddr2 : ''}
                                    value={values.senderAddr2}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 3"
                                    name="senderAddr3"
                                    onBlur={handleBlur}
                                    error={touched.senderAddr3 && !!errors.senderAddr3}
                                    helperText={touched.senderAddr3 && errors.senderAddr3 ? errors.senderAddr3 : ''}
                                    value={values.senderAddr3}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <FormControl fullWidth size="small">
                                    {/* <InputLabel>Sender Country</InputLabel> */}
                                    {/* <Select
                                    value={values.country || ''}
                                    name="country"
                                    size="small"
                                    label="senderCountry"
                                    onChange={(e) => {
                                      handleCountryChangeSender(e, handleChange);
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderCountry && !!errors.senderCountry}
                                  >
                                    {countryList.map((country) => (
                                      <MenuItem key={country.CountryId} value={country.CountryId}>
                                        {country.CountryName}
                                      </MenuItem>
                                    ))}
                                    {!countryList.length && <MenuItem disabled>No country available</MenuItem>}
                                  </Select>
                                  {touched.senderCountry && errors.senderCountry && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.senderCountry}
                                    </Typography>
                                  )} */}
                                    <Autocomplete
                                      options={countryList || []}
                                      getOptionLabel={(country) => country.CountryName || ''}
                                      renderOption={(props, country) => (
                                        <li {...props} key={country.CountryId}>
                                          {country.CountryName}
                                        </li>
                                      )}
                                      isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                                      value={
                                        countryList.find((country) => country.CountryId === values.senderCountry) ||
                                        null
                                      }
                                      name="senderCountry"
                                      onChange={(event, value) => {
                                        if (value) {
                                          setsenderCountryErr(false);
                                          setFieldValue('senderCountry', value.CountryId);
                                          handleCountryChangeSender(value, handleChange);
                                        } else {
                                          setFieldValue('senderCountry', '');
                                        }
                                      }}
                                      onBlur={() => setFieldTouched('senderCountry', true)}
                                      size="small"
                                      disabled
                                      renderInput={(params) => (
                                        <TextField
                                          required
                                          {...params}
                                          label="Sender Country"
                                          value={values.senderCountry ? values.senderCountry : ''}
                                          // error={touched.senderCountry && !!errors.senderCountry}
                                          // helperText={touched.senderCountry && errors.senderCountry}
                                          helperText={senderCountryErr ? 'Sender Country is required' : ''}
                                          FormHelperTextProps={{
                                            style: { color: 'red' },
                                          }}
                                        />
                                      )}
                                      noOptionsText="No country available"
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <FormControl fullWidth size="small">
                                    {/* <InputLabel>State</InputLabel> */}
                                    {/* <Select
                                    value={values.senderState || ''}
                                    name="state"
                                    size="small"
                                    label="State"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.senderState && !!errors.senderState}
                                  >
                                    {senderStateList.map((state) => (
                                      <MenuItem key={state.StateId} value={state.StateId}>
                                        {state.StateName}
                                      </MenuItem>
                                    ))}
                                    {!senderStateList.length && <MenuItem disabled>No state available</MenuItem>}
                                  </Select>
                                  {touched.senderState && errors.senderState && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.senderState}
                                    </Typography>
                                  )} */}
                                    <Autocomplete
                                      options={senderStateList || []} // Options for the Autocomplete
                                      getOptionLabel={(state) => state.StateName || ''}
                                      renderOption={(props, state) => (
                                        <li {...props} key={state.StateId}>
                                          {state.StateName}
                                        </li>
                                      )}
                                      isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                      value={
                                        senderStateList.find((state) => state.StateId === values.senderState) || null
                                      }
                                      name="senderState"
                                      onChange={(event, value) => {
                                        if (value) {
                                          setFieldValue('senderState', value.StateId);
                                        } else {
                                          setFieldValue('senderState', '');
                                        }
                                      }}
                                      onBlur={() => setFieldTouched('senderState', true)}
                                      size="small"
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Sender Province/State"
                                          value={values.senderState ? values.senderState : ''}
                                          // error={touched.senderState && !!errors.senderState}
                                          // helperText={touched.senderState && errors.senderState}
                                        />
                                      )}
                                      noOptionsText="No Province/State available"
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    size="small"
                                    label="City"
                                    type="text"
                                    name="senderCity"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderCity = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderCity && !!errors.senderCity}
                                    helperText={touched.senderCity && errors.senderCity ? errors.senderCity : ''}
                                    value={values.senderCity}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Postal Code"
                                    type="text"
                                    name="senderPincode"
                                    inputRef={(el) => {
                                      fieldRefs.current.senderPincode = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.senderPincode && !!errors.senderPincode}
                                    helperText={
                                      touched.senderPincode && errors.senderPincode ? errors.senderPincode : ''
                                    }
                                    value={values.senderPincode}
                                    onChange={handleChange}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* Receiver details */}
                            <Grid item md={6} xs={12}>
                              <Grid
                                container
                                spacing={2}
                                rowSpacing={2}
                                columnSpacing={2}
                                component={Paper}
                                p={2}
                                pt={0}
                                pl={0}
                                pr={2}
                                elevation={3}
                                sx={{
                                  bgcolor: 'inherit',
                                  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                                }}
                              >
                                <Grid item md={12} xs={12}>
                                  <Divider sx={{ mb: 0 }} variant="fullWidth">
                                    <Chip label="Receiver Details" size="small" variant="outlined" />
                                  </Divider>
                                </Grid>
                                {/* <Grid item md={12} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Name"
                                    type="text"
                                    name="receiverName"
                                    onBlur={handleBlur}
                                    error={touched.receiverName && !!errors.receiverName}
                                    helperText={touched.receiverName && errors.receiverName ? errors.receiverName : ''}
                                    value={values.receiverName}
                                    onChange={handleChange}
                                  />
                                </Grid> */}
                                <Grid item md={12} xs={12}>
                                  <FormControl fullWidth size="small">
                                    <Autocomplete
                                      options={receiverList || []} // Options for the Autocomplete
                                      getOptionLabel={(receiver) => {
                                        if (!receiver) return ''; // Handle null/undefined
                                        if (typeof receiver === 'string') return receiver; // Handle free text input
                                        return `${receiver.receiver_Name}`;
                                      }}
                                      filterOptions={(options, state) => {
                                        const inputValue = state.inputValue.toLowerCase();
                                        return options.filter(
                                          (option) =>
                                            option.receiver_Name.toLowerCase().includes(inputValue) ||
                                            (option.receiver_ContactNo &&
                                              option.receiver_ContactNo.toString().toLowerCase().includes(inputValue))
                                        );
                                      }}
                                      renderOption={(props, receiver) => (
                                        <li {...props} key={receiver.receiver_Id}>
                                          <div>
                                            <strong>{receiver.receiver_Name}</strong>
                                            <div style={{ fontSize: '0.8rem', color: '#666' }}>
                                              {receiver.receiver_ContactNo}
                                            </div>
                                          </div>
                                        </li>
                                      )}
                                      isOptionEqualToValue={(option, value) => {
                                        if (!option || !value) return false;
                                        if (typeof value === 'string') return option.receiver_Name === value;
                                        return option.receiver_Id === value.receiver_Id;
                                      }}
                                      value={
                                        // Handle both object selection and free text input
                                        values.receiverId
                                          ? receiverList.find((r) => r.receiver_Id === values.receiverId) ||
                                            values.receiverName ||
                                            null
                                          : values.receiverName || null
                                      }
                                      name="receiverName"
                                      onChange={(event, value) => {
                                        if (value && typeof value === 'object') {
                                          // Selected from dropdown
                                          setFieldValue('receiverName', value.receiver_Name);
                                          setFieldValue('receiverId', value.receiver_Id);
                                          setFieldValue('receiverAddr1', value.receiver_Address1);
                                          setFieldValue('receiverAddr2', value.receiver_Address2);
                                          setFieldValue('receiverAddr3', value.receiver_Address3);
                                          setFieldValue('receiverCity', value.receiver_City);
                                          setFieldValue('receiverState', value.receiver_Stateid);
                                          setFieldValue('receiverPincode', value.receiver_Pincode);
                                          setFieldValue('receiverPhone', value.receiver_ContactNo);
                                          setFieldValue('receiverAlterPhone', value.receiver_AlterContactNo);
                                          setFieldValue('receiverEmail', value.receiver_EmailId);
                                          setFieldValue('idCardType', value.Sender_Idcard_Type);
                                          setFieldValue('IdCardNo', value.Sender_Idcard_No);
                                          setFieldValue('RecidCardType', value.Receiver_Idcard_Type);
                                          setFieldValue('RecIdCardNo', value.Receiver_Idcard_No);
                                          setFieldValue('nic', value.Nic_No);

                                          const buildImageUrl = (imgPath) => {
                                            if (!imgPath) return '';
                                            if (imgPath.startsWith('http') || imgPath.startsWith('//')) {
                                              return imgPath.includes('?')
                                                ? `${imgPath}&v=${Date.now()}`
                                                : `${imgPath}?v=${Date.now()}`;
                                            }
                                            const origin = sessionStorage.getItem('Origin');
                                            const base =
                                              origin === 'IN'
                                                ? axios.defaults.inImageURL
                                                : origin === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL;
                                            const url = `${base}/${imgPath}`;
                                            return url.includes('?')
                                              ? `${url}&v=${Date.now()}`
                                              : `${url}?v=${Date.now()}`;
                                          };

                                          const senderImg = `CG_FMT${value.Sender_Idcard_No}-${getIdCardNameById(
                                            value.Sender_Idcard_Type
                                          )}.jpg`;
                                          const receiverImg = `CG_BMT${value.Receiver_Idcard_No}-${getIdCardNameById(
                                            value.Receiver_Idcard_Type
                                          )}.jpg`;

                                          setSenderImagePreview(buildImageUrl(senderImg));
                                          setReceiverImagePreview(buildImageUrl(receiverImg));
                                          setSenderImageFile(senderImg || null);
                                          setReceiverImageFile(receiverImg || null);
                                          setSendPreviewBtn(true);
                                          setReceivPreviewBtn(true);
                                        } else {
                                          // Free text input or cleared
                                          setFieldValue('receiverName', value || '');
                                          setFieldValue('receiverId', '');
                                        }
                                      }}
                                      onInputChange={(event, newInputValue, reason) => {
                                        if (reason === 'input' || reason === 'clear') {
                                          setFieldValue('receiverName', newInputValue);
                                        }
                                      }}
                                      onBlur={(event) => {
                                        setFieldTouched('receiverName', true);
                                        // Handle case where user typed but didn't select
                                        const inputValue = event.target.value;
                                        if (inputValue && !values.receiverId) {
                                          const matchedOption = receiverList.find(
                                            (option) =>
                                              `${option.receiver_Name} - ${option.receiver_ContactNo}` === inputValue
                                          );
                                          if (matchedOption) {
                                            setFieldValue('receiverName', matchedOption.receiver_Name);
                                            setFieldValue('receiverId', matchedOption.receiver_Id);
                                          }
                                        }
                                      }}
                                      size="small"
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Name"
                                          inputRef={(el) => {
                                            fieldRefs.current.receiverName = el;
                                          }}
                                          value={values.receiverName ? values.receiverName : ''}
                                          error={touched.receiverName && Boolean(errors.receiverName)}
                                          helperText={touched.receiverName && errors.receiverName}
                                          FormHelperTextProps={{
                                            style: { color: 'red' },
                                          }}
                                          required
                                        />
                                      )}
                                      noOptionsText="No Receiver available"
                                      freeSolo
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    size="small"
                                    label="Contact No"
                                    type="text"
                                    name="receiverPhone"
                                    onWheel={(e) => e.target.blur()}
                                    inputRef={(el) => {
                                      fieldRefs.current.receiverPhone = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverPhone && !!errors.receiverPhone}
                                    helperText={
                                      touched.receiverPhone && errors.receiverPhone ? errors.receiverPhone : ''
                                    }
                                    value={values.receiverPhone}
                                    onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      handleChange({ target: { name: 'receiverPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                    }}
                                    // onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="Alternative Contact No"
                                    type="text"
                                    name="receiverAlterPhone"
                                    onBlur={handleBlur}
                                    error={touched.receiverAlterPhone && !!errors.receiverAlterPhone}
                                    helperText={
                                      touched.receiverAlterPhone && errors.receiverAlterPhone
                                        ? errors.receiverAlterPhone
                                        : ''
                                    }
                                    value={values.receiverAlterPhone}
                                    onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      handleChange({ target: { name: 'receiverAlterPhone', value: numericValue } }); // Manually trigger Formik's handleChange
                                    }}
                                    // onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={12} xs={12}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="Email"
                                    type="email"
                                    name="receiverEmail"
                                    onBlur={handleBlur}
                                    error={touched.receiverEmail && !!errors.receiverEmail}
                                    helperText={
                                      touched.receiverEmail && errors.receiverEmail ? errors.receiverEmail : ''
                                    }
                                    value={values.receiverEmail}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    required
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 1"
                                    name="receiverAddr1"
                                    inputRef={(el) => {
                                      fieldRefs.current.receiverAddr1 = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverAddr1 && !!errors.receiverAddr1}
                                    helperText={
                                      touched.receiverAddr1 && errors.receiverAddr1 ? errors.receiverAddr1 : ''
                                    }
                                    value={values.receiverAddr1}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 2"
                                    name="receiverAddr2"
                                    onBlur={handleBlur}
                                    error={touched.receiverAddr2 && !!errors.receiverAddr2}
                                    helperText={
                                      touched.receiverAddr2 && errors.receiverAddr2 ? errors.receiverAddr2 : ''
                                    }
                                    value={values.receiverAddr2}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  <TextField
                                    multiline
                                    rows={3}
                                    fullWidth
                                    size="small"
                                    label="Address Line 3"
                                    name="receiverAddr3"
                                    onBlur={handleBlur}
                                    error={touched.receiverAddr3 && !!errors.receiverAddr3}
                                    helperText={
                                      touched.receiverAddr3 && errors.receiverAddr3 ? errors.receiverAddr3 : ''
                                    }
                                    value={values.receiverAddr3}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <FormControl fullWidth size="small">
                                    {/* <InputLabel>Country</InputLabel>
                                  <Select
                                    value={values.country || ''}
                                    name="country"
                                    size="small"
                                    label="receiverCountry"
                                    onChange={(e) => {
                                      handleCountryChangereceiver(e, handleChange);
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverCountry && !!errors.receiverCountry}
                                  >
                                    {countryList.map((country) => (
                                      <MenuItem key={country.CountryId} value={country.CountryId}>
                                        {country.CountryName}
                                      </MenuItem>
                                    ))}
                                    {!countryList.length && <MenuItem disabled>No country available</MenuItem>}
                                  </Select>
                                  {touched.receiverCountry && errors.receiverCountry && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.receiverCountry}
                                    </Typography>
                                  )} */}
                                    <Autocomplete
                                      options={countryList || []} // Options for the Autocomplete
                                      getOptionLabel={(country) => country.CountryName || ''} // Display country name
                                      renderOption={(props, country) => (
                                        <li {...props} key={country.CountryId}>
                                          {country.CountryName}
                                        </li>
                                      )}
                                      isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                                      value={
                                        countryList.find((country) => country.CountryId === values.receiverCountry) ||
                                        null
                                      }
                                      name="receiverCountry"
                                      onChange={(event, value) => {
                                        if (value) {
                                          setreceiverCountryErr(false);
                                          setFieldValue('receiverCountry', value.CountryId);
                                          setReceiverCountryId(value.CountryId);
                                          handleCountryChangereceiver(value, handleChange);
                                          // GetShipperPrice(boxDetails);
                                          // GetShipperPrice1(null, value.CountryId, null, boxDetails);
                                          GetNewShipperPrice(value.CountryId, boxDetails);
                                        } else {
                                          setFieldValue('receiverCountry', '');
                                        }
                                      }}
                                      onBlur={() => setFieldTouched('receiverCountry', true)}
                                      size="small"
                                      disabled
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          required
                                          label="Receiver Country"
                                          value={values.receiverCountry ? values.receiverCountry : ''}
                                          // error={touched.receiverCountry && !!errors.receiverCountry}
                                          // helperText={touched.receiverCountry && errors.receiverCountry}
                                          helperText={receiverCountryErr ? 'Receiver Country is required' : ''}
                                          FormHelperTextProps={{
                                            style: { color: 'red' },
                                          }}
                                        />
                                      )}
                                      noOptionsText="No country available"
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <FormControl fullWidth size="small">
                                    {/* <InputLabel>State</InputLabel>
                                  <Select
                                    value={values.receiverState || ''}
                                    name="state"
                                    size="small"
                                    label="State"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.receiverState && !!errors.receiverState}
                                  >
                                    {receiverStateList.map((state) => (
                                      <MenuItem key={state.StateId} value={state.StateId}>
                                        {state.StateName}
                                      </MenuItem>
                                    ))}
                                    {!receiverStateList.length && <MenuItem disabled>No state available</MenuItem>}
                                  </Select>
                                  {touched.receiverState && errors.receiverState && (
                                    <Typography
                                      variant="caption"
                                      color="error"
                                      className="shake-helper-text"
                                      margin="4px 0 0 14px"
                                    >
                                      {errors.receiverState}
                                    </Typography>
                                  )} */}
                                    <Autocomplete
                                      options={receiverStateList || []} // Options for the Autocomplete
                                      getOptionLabel={(state) => state.StateName || ''}
                                      renderOption={(props, state) => (
                                        <li {...props} key={state.StateId}>
                                          {state.StateName}
                                        </li>
                                      )}
                                      isOptionEqualToValue={(option, value) => option?.StateId === value?.StateId}
                                      value={
                                        receiverStateList.find((state) => state.StateId === values.receiverState) ||
                                        null
                                      }
                                      name="receiverState"
                                      onChange={(event, value) => {
                                        if (value) {
                                          setFieldValue('receiverState', value.StateId);
                                        } else {
                                          setFieldValue('receiverState', '');
                                        }
                                      }}
                                      onBlur={() => setFieldTouched('receiverState', true)}
                                      size="small"
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label="Receiver Province/State"
                                          value={values.receiverState ? values.receiverState : ''}
                                          // error={touched.receiverState && !!errors.receiverState}
                                          // helperText={touched.receiverState && errors.receiverState}
                                        />
                                      )}
                                      noOptionsText="No Province/State available"
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    required
                                    size="small"
                                    label="City"
                                    type="text"
                                    name="receiverCity"
                                    inputRef={(el) => {
                                      fieldRefs.current.receiverCity = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverCity && !!errors.receiverCity}
                                    helperText={touched.receiverCity && errors.receiverCity ? errors.receiverCity : ''}
                                    value={values.receiverCity}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    required
                                    fullWidth
                                    size="small"
                                    label="Postal Code"
                                    type="text"
                                    name="receiverPincode"
                                    inputRef={(el) => {
                                      fieldRefs.current.receiverPincode = el;
                                    }}
                                    onBlur={handleBlur}
                                    error={touched.receiverPincode && !!errors.receiverPincode}
                                    helperText={
                                      touched.receiverPincode && errors.receiverPincode ? errors.receiverPincode : ''
                                    }
                                    value={values.receiverPincode}
                                    onChange={handleChange}
                                  />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    label="NIC"
                                    type="text"
                                    name="nic"
                                    inputRef={(el) => {
                                      fieldRefs.current.nic = el;
                                    }}
                                    onBlur={handleBlur}
                                    value={values.nic}
                                    onChange={(e) => {
                                      // Filter to allow only alphanumeric characters and spaces
                                      const alphanumericValue = e.target.value.replace(/[^A-Za-z0-9 ]/g, '');

                                      // Create a synthetic event with the filtered value
                                      const syntheticEvent = {
                                        ...e,
                                        target: {
                                          ...e.target,
                                          name: 'nic',
                                          value: alphanumericValue,
                                        },
                                      };

                                      // Call the original handleChange with filtered value
                                      handleChange(syntheticEvent);
                                    }}
                                    inputProps={{
                                      maxLength: 30,
                                      pattern: '[A-Za-z0-9]*', // HTML5 pattern validation
                                    }}
                                    // disabled={isDisabled}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* ID Card Details Section */}
                        <Grid item xs={12} m={0}>
                          <Grid
                            container
                            spacing={2}
                            rowSpacing={2}
                            columnSpacing={2}
                            component={Paper}
                            p={1}
                            m={0}
                            elevation={3}
                            sx={{
                              width: '100%',
                              bgcolor: 'inherit',
                              boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px',
                            }}
                          >
                            {/* Main container for all three sections in one row */}
                            <Grid container spacing={2} sx={{ mt: 0, p: 0, width: '100%' }}>
                              {/* Sender Section - Left Column */}
                              <Grid item md={4} xs={12}>
                                <Stack direction="column" sx={{ height: '100%' }}>
                                  {/* Sender Image */}
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    border={1}
                                    borderRadius={1}
                                    borderColor="#e0e0e0"
                                    p={1}
                                    justifyContent="center"
                                    sx={{
                                      height: '100%',
                                      bgcolor: 'background.paper',
                                      minHeight: { xs: 'auto', md: '180px' },
                                    }}
                                  >
                                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                      <Box sx={{ textAlign: 'center', width: '100%' }}>
                                        <label htmlFor="fileInputSender">
                                          <img
                                            src={
                                              senderImagePreview || imagepreview
                                              // (senderImageFile === null ||
                                              //   senderImageFile === '' ||
                                              //   !senderImageFile
                                              //   ? imagepreview
                                              //   : NoimageFound)
                                            }
                                            alt="No Img"
                                            className={classes.chooseFileButton}
                                            style={{
                                              width: '100%',
                                              maxWidth: '250px',
                                              height: '150px',
                                              objectFit: 'contain',
                                            }}
                                            onError={(e) => {
                                              e.target.onerror = null; // Prevent infinite loop
                                              e.target.src = imagepreview;
                                              setSendPreviewBtn(false);
                                            }}
                                          />
                                          <input
                                            className={classes.fileInput}
                                            id="fileInputSender"
                                            type="file"
                                            accept="image/jpeg"
                                            name="IDcardFile"
                                            onClick={(event) => {
                                              if (
                                                !values.IdCardNo ||
                                                values.IdCardNo.trim() === '' ||
                                                values.IdCardNo.trim() === '0'
                                              ) {
                                                openSnackBar('Please enter ID Card No before uploading image', 'error');
                                                event.preventDefault();
                                                event.stopPropagation();
                                                return;
                                              }
                                            }}
                                            onChange={(event) => {
                                              handleIdFileChange(event, 'sender', values);
                                              handleChange(event);
                                            }}
                                            style={{ display: 'none' }}
                                            //  disabled={isDisabled}
                                          />
                                        </label>
                                        {(senderImagePreview || senderImageFile) && sendPreviewBtn && (
                                          <Button
                                            onClick={() => handleOpenDialogPreview('sender')}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{
                                              boxShadow: 1,
                                              mt: 1,
                                              width: '100%',
                                              maxWidth: '250px',
                                              mx: 'auto',
                                            }}
                                          >
                                            Preview
                                          </Button>
                                        )}
                                      </Box>
                                    </Stack>
                                  </Stack>

                                  {/* Sender ID Card Type and Number */}
                                  <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                                    <Grid item xs={12} md={12}>
                                      <FormControl fullWidth size="small">
                                        <InputLabel>ID Card Type<span style={{ color: 'red', marginLeft: '2px' }}>*</span></InputLabel>
                                        <Select
                                          value={values.idCardType || ''}
                                          name="idCardType"
                                          size="small"
                                          label="ID Card Type"
                                          onChange={(e) => {
                                            const newValue = e.target.value;

                                            // Check if in edit mode and value has changed from initial
                                            if (
                                              Type === 'Edit' &&
                                              initialValue.idCardType &&
                                              newValue !== initialValue.idCardType
                                            ) {
                                              // If there's an existing image, show confirmation dialog
                                              if (senderImageFile || senderImagePreview) {
                                                setPendingIdCardChanges((prev) => ({
                                                  ...prev,
                                                  sender: { newValue, field: 'idCardType', isTypeChange: true },
                                                }));
                                                setShowIdCardChangeDialog((prev) => ({ ...prev, sender: true }));
                                                return; // Don't update the field yet
                                              }
                                            }

                                            // Update the field immediately if no image or not in edit mode
                                            setFieldValue('IdCardNo', '');
                                            setSenderImageFile(null);
                                            setSenderImagePreview('');
                                            setFieldValue('idCardType', newValue || '');
                                            const senderInput = document.getElementById('fileInputSender');
                                            if (senderInput) {
                                              senderInput.value = '';
                                            }
                                          }}
                                          onBlur={handleBlur}
                                          error={touched.idCardType && !!errors.idCardType}
                                          //  disabled={isDisabled}
                                        >
                                          {idCardTypes.map((idCard) => (
                                            <MenuItem key={idCard.id} value={idCard.id}>
                                              {idCard.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        label={
                                          <span>
                                            ID Card No
                                            {values.idCardType &&
                                            values.idCardType !== '' &&
                                            values.idCardType !== '0' ? (
                                              <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            ) : null}
                                          </span>
                                        }
                                        type="text"
                                        name="IdCardNo"
                                        inputRef={(el) => {
                                          fieldRefs.current.IdCardNo = el;
                                        }}
                                        onBlur={handleBlur}
                                        error={touched.IdCardNo && !!errors.IdCardNo}
                                        helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                                        value={values.IdCardNo || ''}
                                        onChange={(e) => {
                                          const newValue = e.target.value;

                                          // Check if in edit mode and value has changed from initial
                                          if (
                                            Type === 'Edit' &&
                                            initialValue.IdCardNo &&
                                            newValue !== initialValue.IdCardNo
                                          ) {
                                            // If there's an existing image, show confirmation dialog
                                            if (senderImageFile || senderImagePreview) {
                                              setPendingIdCardChanges((prev) => ({
                                                ...prev,
                                                sender: { newValue, field: 'IdCardNo' },
                                              }));
                                              setShowIdCardChangeDialog((prev) => ({ ...prev, sender: true }));
                                              return; // Don't update the field yet
                                            }
                                          }

                                          // Update the field immediately if no image or not in edit mode
                                          handleChange(e);

                                          // Clear the image and file input
                                          setSenderImageFile(null);
                                          setSenderImagePreview('');
                                          const senderInput = document.getElementById('fileInputSender');
                                          if (senderInput) {
                                            senderInput.value = '';
                                          }
                                        }}
                                        disabled={
                                          !(values.idCardType && values.idCardType !== '' && values.idCardType !== '0')
                                        }
                                        inputProps={{ maxLength: 30 }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Stack>
                              </Grid>

                              {/* Remarks Section - Middle Column */}
                              <Grid item md={4} xs={12}>
                                <Stack
                                  direction="column"
                                  justifyContent="center"
                                  alignItems="center"
                                  sx={{
                                    height: '100%',
                                    minHeight: { xs: 'auto', md: '250px' },
                                    p: 2,
                                  }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{
                                      fontWeight: 'bold',
                                      textAlign: 'center',
                                      color: 'text.secondary',
                                      lineHeight: 1.4,
                                    }}
                                  >
                                    {sessionStorage.getItem('Origin') === 'SL' ? (
                                      ''
                                    ) : (
                                      <span style={{ color: 'red', display: 'block', marginBottom: 1 }}>Remarks</span>
                                    )}
                                    {sessionStorage.getItem('Origin') === 'UK'
                                      ? '“Dear Customer kindly upload the receiver document accordingly in the respective image upload option”'
                                      : sessionStorage.getItem('Origin') === 'IN'
                                      ? '“Dear Customer kindly upload the Sender document accordingly in the respective image upload option”'
                                      : ''}
                                  </Typography>
                                </Stack>
                              </Grid>

                              {/* Receiver Section - Right Column */}
                              <Grid item md={4} xs={12}>
                                <Stack direction="column" sx={{ height: '100%' }}>
                                  {/* Receiver Image */}
                                  <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={1}
                                    border={1}
                                    borderRadius={1}
                                    borderColor="#e0e0e0"
                                    p={1}
                                    justifyContent="center"
                                    sx={{
                                      height: '100%',
                                      bgcolor: 'background.paper',
                                      minHeight: { xs: 'auto', md: '180px' },
                                    }}
                                  >
                                    <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                      <Box sx={{ textAlign: 'center', width: '100%' }}>
                                        <label htmlFor="fileInputReceiver">
                                          <img
                                            src={
                                              receiverImagePreview || imagepreview
                                              // (receiverImageFile === null ||
                                              //   receiverImageFile === '' ||
                                              //   !receiverImageFile
                                              //   ? imagepreview
                                              //   : NoimageFound)
                                            }
                                            alt="No Img"
                                            className={classes.chooseFileButton}
                                            style={{
                                              width: '100%',
                                              maxWidth: '250px',
                                              height: '150px',
                                              objectFit: 'contain',
                                            }}
                                            onError={(e) => {
                                              e.target.onerror = null; // Prevent infinite loop
                                              e.target.src = imagepreview;
                                              setReceivPreviewBtn(false);
                                            }}
                                          />
                                          <input
                                            className={classes.fileInput}
                                            id="fileInputReceiver"
                                            type="file"
                                            accept="image/jpeg"
                                            name="RecIDcardFile"
                                            onClick={(event) => {
                                              if (
                                                !values.RecIdCardNo ||
                                                values.RecIdCardNo.trim() === '' ||
                                                values.RecIdCardNo.trim() === '0'
                                              ) {
                                                openSnackBar('Please enter ID Card No before uploading image', 'error');
                                                event.preventDefault();
                                                event.stopPropagation();
                                                return;
                                              }
                                            }}
                                            onChange={(event) => {
                                              handleIdFileChange(event, 'receiver', values);
                                              handleChange(event);
                                            }}
                                            style={{ display: 'none' }}
                                            //  disabled={isDisabled}
                                          />
                                        </label>
                                        {(receiverImagePreview || receiverImageFile) && receivPreviewBtn && (
                                          <Button
                                            onClick={() => handleOpenDialogPreview('receiver')}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            sx={{
                                              boxShadow: 1,
                                              mt: 1,
                                              width: '100%',
                                              maxWidth: '250px',
                                              mx: 'auto',
                                            }}
                                          >
                                            Preview
                                          </Button>
                                        )}
                                      </Box>
                                    </Stack>
                                  </Stack>

                                  {/* Receiver ID Card Type and Number */}
                                  <Grid container spacing={2} sx={{ mt: 0, p: 0 }}>
                                    <Grid item xs={12} md={12}>
                                      <FormControl fullWidth size="small">
                                        <InputLabel>ID Card Type<span style={{ color: 'red', marginLeft: '2px' }}>*</span></InputLabel>
                                        <Select
                                          value={values.RecidCardType || ''}
                                          name="RecidCardType"
                                          size="small"
                                          label="ID Card Type"
                                          onChange={(e) => {
                                            const newValue = e.target.value;

                                            // Check if in edit mode and value has changed from initial
                                            if (
                                              Type === 'Edit' &&
                                              initialValue.RecidCardType &&
                                              newValue !== initialValue.RecidCardType
                                            ) {
                                              // If there's an existing image, show confirmation dialog
                                              if (receiverImageFile || receiverImagePreview) {
                                                setPendingIdCardChanges((prev) => ({
                                                  ...prev,
                                                  receiver: { newValue, field: 'RecidCardType', isTypeChange: true },
                                                }));
                                                setShowIdCardChangeDialog((prev) => ({ ...prev, receiver: true }));
                                                return; // Don't update the field yet
                                              }
                                            }

                                            // Update the field immediately if no image or not in edit mode
                                            setFieldValue('RecIdCardNo', '');
                                            setReceiverImageFile(null);
                                            setReceiverImagePreview('');
                                            setFieldValue('RecidCardType', newValue || '');
                                            const receiverInput = document.getElementById('fileInputReceiver');
                                            if (receiverInput) {
                                              receiverInput.value = '';
                                            }
                                          }}
                                          onBlur={handleBlur}
                                          error={touched.RecidCardType && !!errors.RecidCardType}
                                          //  disabled={isDisabled}
                                        >
                                          {idCardTypes.map((idCard) => (
                                            <MenuItem key={idCard.id} value={idCard.id}>
                                              {idCard.name}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </FormControl>
                                    </Grid>

                                    <Grid item xs={12} md={12}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        label={
                                          <span>
                                            ID Card No
                                            {values.RecidCardType &&
                                            values.RecidCardType !== '' &&
                                            values.RecidCardType !== '0' ? (
                                              <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                                            ) : null}
                                          </span>
                                        }
                                        type="text"
                                        name="RecIdCardNo"
                                        inputRef={(el) => {
                                          fieldRefs.current.RecIdCardNo = el;
                                        }}
                                        onBlur={handleBlur}
                                        error={touched.RecIdCardNo && !!errors.RecIdCardNo}
                                        helperText={touched.RecIdCardNo && errors.RecIdCardNo ? errors.RecIdCardNo : ''}
                                        value={values.RecIdCardNo || ''}
                                        onChange={(e) => {
                                          const newValue = e.target.value;

                                          // Check if in edit mode and value has changed from initial
                                          if (
                                            Type === 'Edit' &&
                                            initialValue.RecIdCardNo &&
                                            newValue !== initialValue.RecIdCardNo
                                          ) {
                                            // If there's an existing image, show confirmation dialog
                                            if (receiverImageFile || receiverImagePreview) {
                                              setPendingIdCardChanges((prev) => ({
                                                ...prev,
                                                receiver: { newValue, field: 'RecIdCardNo' },
                                              }));
                                              setShowIdCardChangeDialog((prev) => ({ ...prev, receiver: true }));
                                              return; // Don't update the field yet
                                            }
                                          }

                                          // Update the field immediately if no image or not in edit mode
                                          handleChange(e);

                                          // Clear the image and file input
                                          setReceiverImageFile(null);
                                          setReceiverImagePreview('');
                                          const receiverInput = document.getElementById('fileInputReceiver');
                                          if (receiverInput) {
                                            receiverInput.value = '';
                                          }
                                        }}
                                        disabled={
                                          !(
                                            values.RecidCardType &&
                                            values.RecidCardType !== '' &&
                                            values.RecidCardType !== '0'
                                          )
                                        }
                                        inputProps={{ maxLength: 30 }}
                                      />
                                    </Grid>
                                  </Grid>
                                </Stack>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* ID Card Change Confirmation Dialog for Sender */}
                        <Dialog
                          open={showIdCardChangeDialog.sender}
                          onClose={() => setShowIdCardChangeDialog((prev) => ({ ...prev, sender: false }))}
                        >
                          <DialogTitle>
                            {pendingIdCardChanges.sender?.isTypeChange
                              ? 'Confirm ID Card Type Change'
                              : 'Confirm ID Card Number Change'}
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              {pendingIdCardChanges.sender?.isTypeChange
                                ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                                : 'If you change the ID card number, the existing ID card image will be removed.'}
                              <br />
                              <br />
                              Do you want to proceed? You will need to upload a new ID card image
                              {pendingIdCardChanges.sender?.isTypeChange ? ' and ID card number.' : '.'}
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => {
                                // User clicked Cancel - revert to original value
                                if (pendingIdCardChanges.sender?.field === 'idCardType') {
                                  setFieldValue('idCardType', initialValue.idCardType || '');
                                } else {
                                  setFieldValue('IdCardNo', initialValue.IdCardNo || '');
                                }
                                setShowIdCardChangeDialog((prev) => ({ ...prev, sender: false }));
                                setPendingIdCardChanges((prev) => ({ ...prev, sender: null }));
                              }}
                              color="primary"
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                // User clicked Confirm - proceed with change
                                if (pendingIdCardChanges.sender?.field === 'idCardType') {
                                  setFieldValue('idCardType', pendingIdCardChanges.sender.newValue);
                                  // Also clear ID card number when type changes
                                  setFieldValue('IdCardNo', '');
                                } else {
                                  setFieldValue('IdCardNo', pendingIdCardChanges.sender.newValue);
                                }

                                // Clear the image and file input
                                setSenderImageFile(null);
                                setSenderImagePreview('');
                                const senderInput = document.getElementById('fileInputSender');
                                if (senderInput) {
                                  senderInput.value = '';
                                }

                                setShowIdCardChangeDialog((prev) => ({ ...prev, sender: false }));
                                setPendingIdCardChanges((prev) => ({ ...prev, sender: null }));
                              }}
                              color="error"
                              variant="contained"
                            >
                              Confirm & Remove Image
                            </Button>
                          </DialogActions>
                        </Dialog>

                        {/* ID Card Change Confirmation Dialog for Receiver */}
                        <Dialog
                          open={showIdCardChangeDialog.receiver}
                          onClose={() => setShowIdCardChangeDialog((prev) => ({ ...prev, receiver: false }))}
                        >
                          <DialogTitle>
                            {pendingIdCardChanges.receiver?.isTypeChange
                              ? 'Confirm ID Card Type Change'
                              : 'Confirm ID Card Number Change'}
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText>
                              {pendingIdCardChanges.receiver?.isTypeChange
                                ? 'If you change the ID card type, the existing ID card image and ID card number will be removed.'
                                : 'If you change the ID card number, the existing ID card image will be removed.'}
                              <br />
                              <br />
                              Do you want to proceed? You will need to upload a new ID card image
                              {pendingIdCardChanges.receiver?.isTypeChange ? ' and ID card number.' : '.'}
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button
                              onClick={() => {
                                // User clicked Cancel - revert to original value
                                if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                                  setFieldValue('RecidCardType', initialValue.RecidCardType || '');
                                } else {
                                  setFieldValue('RecIdCardNo', initialValue.RecIdCardNo || '');
                                }
                                setShowIdCardChangeDialog((prev) => ({ ...prev, receiver: false }));
                                setPendingIdCardChanges((prev) => ({ ...prev, receiver: null }));
                              }}
                              color="primary"
                            >
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                // User clicked Confirm - proceed with change
                                if (pendingIdCardChanges.receiver?.field === 'RecidCardType') {
                                  setFieldValue('RecidCardType', pendingIdCardChanges.receiver.newValue);
                                  // Also clear ID card number when type changes
                                  setFieldValue('RecIdCardNo', '');
                                } else {
                                  setFieldValue('RecIdCardNo', pendingIdCardChanges.receiver.newValue);
                                }

                                // Clear the image and file input
                                setReceiverImageFile(null);
                                setReceiverImagePreview('');
                                const receiverInput = document.getElementById('fileInputReceiver');
                                if (receiverInput) {
                                  receiverInput.value = '';
                                }

                                setShowIdCardChangeDialog((prev) => ({ ...prev, receiver: false }));
                                setPendingIdCardChanges((prev) => ({ ...prev, receiver: null }));
                              }}
                              color="error"
                              variant="contained"
                            >
                              Confirm & Remove Image
                            </Button>
                          </DialogActions>
                        </Dialog>

                        <Grid item md={12} xs={12}>
                          <Divider sx={{ my: 2 }} variant="middle">
                            {/* <Chip label="Collection/Drop Details" size="small" color="success" variant="outlined" /> */}
                            <Chip label="Branch Details" size="small" color="success" variant="outlined" />
                          </Divider>
                        </Grid>
                        {/* <Grid item md={6} xs={12}>
                          <FormControl fullWidth size="small" required>
                            <InputLabel>Collection/Drop</InputLabel>
                            <Select
                              value={values.pickUpType || ''}
                              name="pickUpType"
                              size="small"
                              label="Collection/Drop"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.pickUpType && !!errors.pickUpType}
                              required
                            >
                              {pickupTypes.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            {touched.pickUpType && errors.pickUpType && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.pickUpType}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid> */}

                        <Grid item md={12} xs={12}>
                          <FormControl fullWidth size="small" required>
                            <InputLabel>Branch</InputLabel>
                            <Select
                              value={values.branch || ''}
                              name="branch"
                              inputRef={(el) => {
                                fieldRefs.current.branch = el;
                              }}
                              size="small"
                              label="Branch"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.branch && !!errors.branch}
                              disabled={isDraft ? false : sessionStorage.getItem('userRole') === 'Sales'}
                              required
                            >
                              {branchList.length > 0 ? (
                                branchList.map((branch) => (
                                  <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                    {branch.BranchName}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No branches available</MenuItem>
                              )}
                            </Select>
                            {touched.branch && errors.branch && (
                              <Typography
                                variant="caption"
                                color="error"
                                className="shake-helper-text"
                                margin="4px 0 0 14px"
                              >
                                {errors.branch}
                              </Typography>
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item md={12} xs={12}>
                          <Divider sx={{ my: 2 }} variant="middle">
                            <Chip label="Box Details" size="small" color="info" variant="outlined" />
                          </Divider>
                        </Grid>

                        {boxDetails.length > 0 &&
                          boxDetails.map((box, index) => (
                            <Grid item md={12} xs={12} key={index}>
                              <Paper
                                elevation={2}
                                sx={{
                                  p: 2,
                                  mb: 1,
                                  borderRadius: 2,
                                  border: '1px solid',
                                  borderColor: 'divider',
                                  backgroundColor: 'background.paper',
                                  '&:hover': {
                                    boxShadow: 3,
                                  },
                                  transition: 'all 0.3s ease',
                                }}
                              >
                                <Typography variant="h6" align="left" color="#295F98" sx={{ pb: 1 }}>
                                  Box {box.boxNo} - Details & Descriptions
                                </Typography>
                                <Accordion
                                  expanded={expanded[index] || false}
                                  py={2}
                                  sx={{
                                    backgroundColor: 'inherit',
                                    border: 0,
                                    borderColor: '#80808038',
                                    borderRadius: 2,
                                    boxShadow: 1,
                                    p: 0,
                                    mt: 0.5,
                                    mb: 1,
                                    cursor: 'pointer',
                                  }}
                                  elevation={7}
                                >
                                  <AccordionSummary
                                    aria-controls={`panel${index}bh-content`}
                                    id={`panel${index}bh-header`}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      toggleAccordion(index);
                                    }}
                                    sx={{
                                      '&.Mui-expanded': {
                                        backgroundColor: 'transparent',
                                      },
                                      '&:focus-within': {
                                        backgroundColor: 'transparent',
                                      },
                                      pb: 1,
                                    }}
                                  >
                                    <Grid container spacing={2} alignItems="center">
                                      <Grid item md={2} xs={12}>
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="No of Items"
                                          // type="number"
                                          type="text"
                                          inputProps={{ inputMode: 'numeric' }}
                                          value={box.noOfItems}
                                          onWheel={(e) => e.target.blur()}
                                          onChange={(e) => {
                                            const updatedBoxes = [...boxDetails];
                                            const newNoOfItems = parseFloat(e.target.value) || '';
                                            if (newNoOfItems > 0 || newNoOfItems === '') {
                                              updatedBoxes[index].noOfItems = newNoOfItems;
                                              setBoxDetails(updatedBoxes);
                                            }
                                          }}
                                          name={`boxDetails[${index}].noOfItems`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].noOfItems`] &&
                                              touched[`boxDetails[${index}].noOfItems`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].noOfItems`] &&
                                            errors[`boxDetails[${index}].noOfItems`]
                                          }
                                          disabled={!boxLoadEnabled[index]}
                                          required
                                          onClick={(e) => {
                                            e.stopPropagation(); // This prevents the click from bubbling up to the accordion
                                          }}
                                          // Also add this to prevent focus from triggering accordion
                                          onFocus={(e) => {
                                            e.stopPropagation();
                                          }}
                                        />
                                      </Grid>

                                      {boxLoadEnabled[index] && (
                                        <Grid item md={1} xs={12}>
                                          <Button
                                            onClick={async () => {
                                              showLoading();
                                              // if (!validateBoxDetails(boxDetails[index], index)) {
                                              //   hideLoading();
                                              //   return;
                                              // }
                                              const uom = uomList.find((i) => i.DefaultUOM === 'Y') || {
                                                UOM_Id: 0,
                                                UOM_Description: '',
                                              };
                                              const updatedBoxes = [...boxDetails];
                                              updatedBoxes[index].goods = Array.from(
                                                { length: updatedBoxes[index].noOfItems },
                                                () => ({
                                                  goodsName: '',
                                                  uom: '',
                                                  UOM_Id: uom.UOM_Id,
                                                  UOM_Description: uom.UOM_Description,
                                                  quantity: '',
                                                  rate: '',
                                                  value: '',
                                                  newGoods: 'N',
                                                  image: null,
                                                  GoodsId: '0',
                                                })
                                              );
                                              setBoxDetails(updatedBoxes);
                                              setBoxLoadEnabled((prev) => ({
                                                ...prev,
                                                [index]: false,
                                              }));
                                              hideLoading();
                                              toggleAccordion(index);
                                            }}
                                            variant="contained"
                                            color="warning"
                                            size="medium"
                                            fullWidth
                                          >
                                            Load
                                          </Button>
                                        </Grid>
                                      )}

                                      <Grid item md={box.goods.length > 0 ? 8 : 7} xs={12}>
                                        <Stack
                                          direction="row"
                                          spacing={1}
                                          alignItems="center"
                                          justifyContent="flex-end"
                                        >
                                          {boxDetails.length > 1 && (
                                            <IconButton
                                              aria-label="delete"
                                              color="error"
                                              onClick={() => handleOpenConfirmDialog(index)}
                                              // disabled={isDisabled}
                                            >
                                              <DeleteOutlineIcon />
                                            </IconButton>
                                          )}

                                          <Divider orientation="vertical" flexItem />

                                          <Button
                                            variant="text"
                                            color="secondary"
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleAccordion(index);
                                            }}
                                            sx={{
                                              textTransform: 'none',
                                              minWidth: 'fit-content',
                                              px: 0.5,
                                              fontSize: '0.85rem',
                                              whiteSpace: 'nowrap',
                                              overflow: 'hidden',
                                              textOverflow: 'ellipsis',
                                            }}
                                          >
                                            {expanded[index] ? 'Hide Goods' : 'View Goods'}
                                          </Button>

                                          <IconButton
                                            aria-label="expand"
                                            color="secondary"
                                            size="small"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleAccordion(index);
                                            }}
                                            sx={{
                                              backgroundColor: expanded[index] ? 'action.hover' : 'transparent',
                                              borderRadius: '50%',
                                            }}
                                          >
                                            <ExpandMoreIcon
                                              sx={{
                                                transform: expanded[index] ? 'rotate(180deg)' : 'rotate(0deg)',
                                                transition: 'transform 0.3s ease',
                                              }}
                                            />
                                          </IconButton>
                                        </Stack>
                                      </Grid>
                                    </Grid>
                                  </AccordionSummary>

                                  <AccordionDetails>
                                    {box.goods.length > 0 && (
                                      <>
                                        <Divider>
                                          <Chip
                                            label="Goods Description"
                                            size="small"
                                            color="primary"
                                            variant="outlined"
                                          />
                                        </Divider>
                                        <Stack justifyContent={'flex-end'} alignItems={'flex-end'} my={1}>
                                          <Button
                                            onClick={() => handleOpenDialog1()}
                                            variant="outlined"
                                            color="success"
                                            size="small"
                                          >
                                            Create New Item
                                          </Button>
                                        </Stack>
                                        <Grid container spacing={2} my={1}>
                                          {box.goods.map((goods, goodsIndex) => {
                                            const filteredGoodsList = goodsList.filter(
                                              (item) =>
                                                !box.goods.some(
                                                  (otherGoods, otherIndex) =>
                                                    otherIndex !== goodsIndex &&
                                                    Number(otherGoods.GoodsId) === Number(item.GoodsId)
                                                )
                                            );
                                            return (
                                              <Grid item md={12} xs={12} key={`${index}-${goodsIndex}`}>
                                                <Paper
                                                  elevation={2}
                                                  sx={{
                                                    p: 2,
                                                    mb: 1,
                                                    borderRadius: 2,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    backgroundColor: 'background.paper',
                                                    '&:hover': {
                                                      boxShadow: 3,
                                                    },
                                                    transition: 'all 0.3s ease',
                                                  }}
                                                >
                                                  <Grid container spacing={2}>
                                                    <Grid item md={9} xs={12}>
                                                      <Stack
                                                        direction="row"
                                                        spacing={2}
                                                        sx={{
                                                          justifyContent: 'space-evenly',
                                                          alignItems: 'center',
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="subtitle2"
                                                          align="center"
                                                          sx={{
                                                            bgcolor: goods.newGoods === 'Y' ? 'orange' : '#55679C',
                                                            borderRadius: '100%',
                                                            color: 'white',
                                                            width: '30px', // Set equal width
                                                            height: '30px', // Set equal height
                                                            display: 'flex', // Ensure proper alignment
                                                            alignItems: 'center', // Center content vertically
                                                            justifyContent: 'center', // Center content horizontally
                                                          }}
                                                        >
                                                          {goodsIndex + 1}
                                                        </Typography>

                                                        {goods.newGoods === 'Y' && goods.GoodsId === '0' ? (
                                                          <Tooltip
                                                            title={goods.goodsName || ''}
                                                            placement="top"
                                                            arrow
                                                            disableHoverListener={!goods.goodsName} // Only show if there's a value
                                                          >
                                                            <TextField
                                                              required
                                                              fullWidth
                                                              size="small"
                                                              label={
                                                                goods.APPROVAL === 'R' ? (
                                                                  <span>
                                                                    Goods{' '}
                                                                    <span style={{ color: 'red' }}>
                                                                      ( Rejected in Approval)
                                                                    </span>
                                                                  </span>
                                                                ) : goods.APPROVAL === 'Y' ? (
                                                                  <span>
                                                                    Goods{' '}
                                                                    <span style={{ color: 'green' }}>( Approved)</span>
                                                                  </span>
                                                                ) : (
                                                                  'Goods'
                                                                )
                                                              }
                                                              value={goods.goodsName}
                                                              onChange={(e) =>
                                                                handleGoodsChangeY(
                                                                  index,
                                                                  goodsIndex,
                                                                  'goodsName',
                                                                  e.target.value
                                                                )
                                                              }
                                                              disabled={
                                                                goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'
                                                              }
                                                              name={`boxDetails[${index}].goods[${goodsIndex}].goodsName`}
                                                              error={Boolean(
                                                                errors[
                                                                  `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ] &&
                                                                  touched[
                                                                    `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                  ]
                                                              )}
                                                              helperText={
                                                                touched[
                                                                  `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ] &&
                                                                errors[
                                                                  `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                ]
                                                              }
                                                              onBlur={handleBlur}
                                                            />
                                                          </Tooltip>
                                                        ) : (
                                                          <Autocomplete
                                                            fullWidth
                                                            size="small"
                                                            options={filteredGoodsList} // Array of goods options
                                                            filterOptions={startsWithFilter} // Custom filter
                                                            getOptionLabel={(option) => option.GoodsName || ''} // Customize display value
                                                            renderOption={(props, option) => (
                                                              <li {...props} key={option.GoodsId}>
                                                                {option.GoodsName}
                                                              </li>
                                                            )}
                                                            value={
                                                              goodsList.find(
                                                                (item) => Number(item.GoodsId) === Number(goods.GoodsId)
                                                              ) || null
                                                            }
                                                            disabled={goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'}
                                                            onChange={(event, value) => {
                                                              if (value?.NotApplicable === 'Y') {
                                                                alert(
                                                                  'This item is not applicable and cannot be selected.'
                                                                );
                                                                return;
                                                              }
                                                              // handleGoodsChange(index, goodsIndex, 'goodsName', value ? value.GoodsName : ''); // Update value
                                                              handleGoodsChange(
                                                                index,
                                                                goodsIndex,
                                                                'goods',
                                                                value || {}
                                                              );
                                                            }}
                                                            isOptionEqualToValue={(option, value) =>
                                                              option.GoodsId === value?.GoodsId
                                                            }
                                                            renderInput={(params) => (
                                                              <Tooltip
                                                                title={params.inputProps.value || ''}
                                                                placement="top"
                                                                arrow
                                                                disableHoverListener={!params.inputProps.value} // Only show if there's a value
                                                              >
                                                                <TextField
                                                                  required
                                                                  {...params}
                                                                  label={
                                                                    goods.APPROVAL === 'R' ? (
                                                                      <span>
                                                                        Goods{' '}
                                                                        <span style={{ color: 'red' }}>
                                                                          ( Rejected in Approval)
                                                                        </span>
                                                                      </span>
                                                                    ) : goods.APPROVAL === 'Y' ? (
                                                                      <span>
                                                                        Goods{' '}
                                                                        <span style={{ color: 'green' }}>
                                                                          ( Approved)
                                                                        </span>
                                                                      </span>
                                                                    ) : (
                                                                      'Goods'
                                                                    )
                                                                  }
                                                                  name={`boxDetails[${index}].goods[${goodsIndex}].goodsName`}
                                                                  error={Boolean(
                                                                    errors[
                                                                      `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                    ] &&
                                                                      touched[
                                                                        `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                      ]
                                                                  )}
                                                                  helperText={
                                                                    touched[
                                                                      `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                    ] &&
                                                                    errors[
                                                                      `boxDetails[${index}].goods[${goodsIndex}].goodsName`
                                                                    ]
                                                                  }
                                                                  onBlur={handleBlur}
                                                                />
                                                              </Tooltip>
                                                            )}
                                                          />
                                                        )}
                                                      </Stack>
                                                    </Grid>
                                                    {hideUom && (
                                                      <Grid item md={3} xs={12}>
                                                        <Autocomplete
                                                          fullWidth
                                                          size="small"
                                                          options={uomList} // Array of goods options
                                                          getOptionLabel={(option) => option.UOM_Description || ''} // Customize display value
                                                          renderOption={(props, option) => (
                                                            <li {...props} key={option.UOM_Id}>
                                                              {option.UOM_Description}
                                                            </li>
                                                          )}
                                                          disabled={goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'}
                                                          value={
                                                            uomList.find((item) => item.UOM_Id === goods.UOM_Id) || null
                                                          }
                                                          onChange={(event, value) => {
                                                            handleGoodsChange(index, goodsIndex, 'uom', value || {}); // Update value
                                                          }}
                                                          isOptionEqualToValue={(option, value) =>
                                                            option.UOM_Id === value?.UOM_Id
                                                          }
                                                          renderInput={(params) => (
                                                            <TextField
                                                              {...params}
                                                              label="UOM"
                                                              name={`boxDetails[${index}].goods[${goodsIndex}].uom`}
                                                              error={Boolean(
                                                                errors[
                                                                  `boxDetails[${index}].goods[${goodsIndex}].uom`
                                                                ] &&
                                                                  touched[
                                                                    `boxDetails[${index}].goods[${goodsIndex}].uom`
                                                                  ]
                                                              )}
                                                              helperText={
                                                                touched[
                                                                  `boxDetails[${index}].goods[${goodsIndex}].uom`
                                                                ] &&
                                                                errors[`boxDetails[${index}].goods[${goodsIndex}].uom`]
                                                              }
                                                              onBlur={handleBlur}
                                                            />
                                                          )}
                                                        />
                                                      </Grid>
                                                    )}
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        required
                                                        fullWidth
                                                        size="small"
                                                        label="Quantity"
                                                        type="number"
                                                        //               type="text"
                                                        // inputProps={{ inputMode: 'numeric' }}
                                                        onKeyDown={(e) => {
                                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                          }
                                                        }}
                                                        value={goods.quantity}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => {
                                                          const newQty = parseFloat(e.target.value) || '';
                                                          if (newQty > 0 || newQty === '') {
                                                            handleGoodsChange(index, goodsIndex, 'quantity', newQty);
                                                          }
                                                        }}
                                                        disabled={goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'}
                                                        name={`boxDetails[${index}].goods[${goodsIndex}].quantity`}
                                                        onBlur={handleBlur}
                                                        error={Boolean(
                                                          errors[
                                                            `boxDetails[${index}].goods[${goodsIndex}].quantity`
                                                          ] &&
                                                            touched[
                                                              `boxDetails[${index}].goods[${goodsIndex}].quantity`
                                                            ]
                                                        )}
                                                        helperText={
                                                          touched[
                                                            `boxDetails[${index}].goods[${goodsIndex}].quantity`
                                                          ] &&
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].quantity`]
                                                        }
                                                      />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                      <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Rate"
                                                        type="number"
                                                        //               type="text"
                                                        // inputProps={{ inputMode: 'numeric' }}
                                                        onKeyDown={(e) => {
                                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                                            e.preventDefault();
                                                          }
                                                        }}
                                                        value={goods.rate}
                                                        onWheel={(e) => e.target.blur()}
                                                        disabled={goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'}
                                                        onChange={(e) => {
                                                          const newRate = parseFloat(e.target.value) || '';
                                                          if (newRate > 0 || newRate === '') {
                                                            handleGoodsChange(index, goodsIndex, 'rate', newRate);
                                                          }
                                                        }}
                                                        onBlur={handleBlur}
                                                        name={`boxDetails[${index}].goods[${goodsIndex}].rate`}
                                                        error={Boolean(
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                            touched[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                        )}
                                                        helperText={
                                                          touched[`boxDetails[${index}].goods[${goodsIndex}].rate`] &&
                                                          errors[`boxDetails[${index}].goods[${goodsIndex}].rate`]
                                                        }
                                                      />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                      <Stack
                                                        direction="row"
                                                        spacing={1}
                                                        sx={{
                                                          justifyContent: 'space-evenly',
                                                          alignItems: 'center',
                                                        }}
                                                      >
                                                        <TextField
                                                          fullWidth
                                                          size="small"
                                                          label="Value"
                                                          type="number"
                                                          value={goods.value}
                                                          onWheel={(e) => e.target.blur()}
                                                          name={`boxDetails[${index}].goods[${goodsIndex}].value`}
                                                          onBlur={handleBlur}
                                                          error={Boolean(
                                                            errors[`boxDetails[${index}].goods[${goodsIndex}].value`] &&
                                                              touched[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                          )}
                                                          helperText={
                                                            touched[
                                                              `boxDetails[${index}].goods[${goodsIndex}].value`
                                                            ] &&
                                                            errors[`boxDetails[${index}].goods[${goodsIndex}].value`]
                                                          }
                                                          disabled
                                                        />
                                                        {goods.newGoods === 'Y' && (
                                                          <>
                                                            <Stack direction={'column'} spacing={2}>
                                                              <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                spacing={1}
                                                                border={1}
                                                                borderRadius={1}
                                                                borderColor="#e0e0e0"
                                                                p={1}
                                                                justifyContent="center"
                                                              >
                                                                <Stack
                                                                  direction="row"
                                                                  alignItems="center"
                                                                  justifyContent={'center'}
                                                                  spacing={1}
                                                                >
                                                                  <Box title="click to add image">
                                                                    <label htmlFor={`fileInput-${index}-${goodsIndex}`}>
                                                                      <img
                                                                        src={
                                                                          /\.(jpg|jpeg|png|gif)$/i.test(goods.image)
                                                                            ? `${axios.defaults.commonImageURL}/Cargo/${goods.image}`
                                                                            : imagePreviews[`${index}-${goodsIndex}`] ||
                                                                              imagepreview
                                                                        } // Use preview URL
                                                                        alt="imgfor"
                                                                        className={classes.chooseFileButton}
                                                                        style={{
                                                                          maxWidth: '22px',
                                                                          maxHeight: '22px',
                                                                          minWidth: '22px',
                                                                          minHeight: '22px',
                                                                          objectFit: 'contain',
                                                                          cursor: 'pointer',
                                                                        }}
                                                                      />
                                                                      <input
                                                                        // disabled={
                                                                        //   goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'
                                                                        // }
                                                                        className={classes.fileInput}
                                                                        id={`fileInput-${index}-${goodsIndex}`}
                                                                        type="file"
                                                                        accept="image/jpeg"
                                                                        name="IDcardFile"
                                                                        onChange={(event) => {
                                                                          handleFileChange(
                                                                            event,
                                                                            'photo',
                                                                            index,
                                                                            goodsIndex
                                                                          ); // Pass boxIndex and goodsIndex
                                                                        }}
                                                                        style={{ display: 'none' }}
                                                                      />
                                                                    </label>
                                                                  </Box>
                                                                </Stack>
                                                              </Stack>
                                                            </Stack>
                                                            {sessionStorage.getItem('userRole') === 'Admin' && (
                                                              <Button
                                                                onClick={() => {
                                                                  handleOpenDialog(index, goodsIndex, goods);
                                                                }}
                                                                variant="contained"
                                                                color={
                                                                  goods?.APPROVAL === 'Y'
                                                                    ? 'warning'
                                                                    : goods?.APPROVAL === 'R'
                                                                    ? 'error'
                                                                    : 'success'
                                                                }
                                                                size="medium"
                                                                fullWidth
                                                                startIcon={<AddTaskIcon />}
                                                              >
                                                                {goods?.APPROVAL === 'Y'
                                                                  ? 'Approved '
                                                                  : goods?.APPROVAL === 'R'
                                                                  ? 'Rejected'
                                                                  : 'Approve'}
                                                              </Button>
                                                            )}
                                                            {goods?.APPROVAL === 'N' &&
                                                              sessionStorage.getItem('userRole') !== 'Admin' && (
                                                                <IconButton
                                                                  aria-label=""
                                                                  onClick={() => {
                                                                    handleOpenDialog(index, goodsIndex, goods);
                                                                  }}
                                                                  color="info"
                                                                >
                                                                  <InfoIcon />
                                                                </IconButton>
                                                              )}
                                                            {goods?.APPROVAL !== 'N' &&
                                                              sessionStorage.getItem('userRole') !== 'Admin' && (
                                                                <Button
                                                                  onClick={() => {
                                                                    handleOpenDialog(index, goodsIndex, goods);
                                                                  }}
                                                                  variant="contained"
                                                                  color={
                                                                    goods?.APPROVAL === 'Y'
                                                                      ? 'warning'
                                                                      : goods?.APPROVAL === 'R'
                                                                      ? 'error'
                                                                      : 'success'
                                                                  }
                                                                  size="medium"
                                                                  fullWidth
                                                                  startIcon={<AddTaskIcon />}
                                                                >
                                                                  {goods?.APPROVAL === 'Y'
                                                                    ? 'Approved '
                                                                    : goods?.APPROVAL === 'R'
                                                                    ? 'Rejected'
                                                                    : 'Approve'}
                                                                </Button>
                                                              )}
                                                          </>
                                                        )}
                                                        {box.goods.length > 1 && (
                                                          <IconButton
                                                            aria-label="delete"
                                                            onClick={() => handleDeleteGoods(index, goodsIndex)}
                                                            // disabled={goods.APPROVAL !== 'Y' && goods.newGoods === 'Y'}
                                                            color="error"
                                                          >
                                                            <HighlightOffIcon />
                                                          </IconButton>
                                                        )}
                                                      </Stack>
                                                    </Grid>
                                                  </Grid>
                                                </Paper>
                                              </Grid>
                                            );
                                          })}
                                        </Grid>
                                        <Stack justifyContent={'center'} alignItems={'center'} mt={2}>
                                          <Button
                                            onClick={() => {
                                              handleAddGoods(index, 'N');
                                            }}
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            startIcon={<AddIcon />}
                                          >
                                            Add More Item
                                          </Button>
                                        </Stack>
                                        <Typography variant="h6" align="right" color="#347928" mt={2} mx={2}>
                                          Total: {getTotalValue(index)}
                                        </Typography>
                                      </>
                                    )}
                                  </AccordionDetails>
                                </Accordion>

                                <Grid item md={12} xs={12}>
                                  <Stack
                                    direction="row"
                                    spacing={2}
                                    sx={{
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      width: '100%',
                                    }}
                                  >
                                    <Typography variant="h6" align="left" color="#295F98" sx={{ pb: 1 }}>
                                      Dimensions & Weights
                                    </Typography>
                                  </Stack>
                                </Grid>

                                <Grid
                                  item
                                  md={box.goods.length > 0 ? 12 : 11}
                                  xs={12}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <Grid container spacing={2}>
                                    <Grid item md={3} xs={12}>
                                      <Autocomplete
                                        fullWidth
                                        size="small"
                                        options={BoxType}
                                        getOptionLabel={(option) => option.label || ''}
                                        renderOption={(props, option) => (
                                          <li {...props} key={option.value}>
                                            {option.label}
                                          </li>
                                        )}
                                        value={BoxType.find((item) => item.value === box.BoxType) || null}
                                        // disabled={isDisabled}
                                        onChange={(event, value) => {
                                          const updatedBoxes = [...boxDetails];
                                          updatedBoxes[index] = {
                                            ...updatedBoxes[index],
                                            BoxType: value ? value.value : null,
                                            length: '',
                                            width: '',
                                            height: '',
                                            dimensionType: 'CM',
                                            BOXTYPEID: null,
                                            BoxSize: '',
                                            grossWeight: '',
                                            cubicWeight: '',
                                          };
                                          setBoxDetails(updatedBoxes);
                                          setInitialValue(values);
                                        }}
                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Box"
                                            name={`boxDetails[${index}].BoxType`}
                                            onBlur={handleBlur}
                                            error={Boolean(
                                              errors[`boxDetails[${index}].BoxType`] &&
                                                touched[`boxDetails[${index}].BoxType`]
                                            )}
                                            helperText={
                                              touched[`boxDetails[${index}].BoxType`] &&
                                              errors[`boxDetails[${index}].BoxType`]
                                            }
                                            required
                                          />
                                        )}
                                      />
                                    </Grid>

                                    <Grid item md={3} xs={12}>
                                      {box.BoxType === 'Custom' ? (
                                        <TextField
                                          fullWidth
                                          size="small"
                                          label="Box Type"
                                          type="text"
                                          required
                                          value={box.BoxSize}
                                          // disabled={isDisabled}
                                          onChange={(e) => {
                                            setInitialValue(values);
                                            const updatedBoxes = [...boxDetails];
                                            updatedBoxes[index].BoxSize = e.target.value;
                                            setBoxDetails(updatedBoxes);
                                          }}
                                          name={`boxDetails[${index}].BoxSize`}
                                          onBlur={handleBlur}
                                          error={Boolean(
                                            errors[`boxDetails[${index}].BoxSize`] &&
                                              touched[`boxDetails[${index}].BoxSize`]
                                          )}
                                          helperText={
                                            touched[`boxDetails[${index}].BoxSize`] &&
                                            errors[`boxDetails[${index}].BoxSize`]
                                          }
                                        />
                                      ) : (
                                        <Autocomplete
                                          fullWidth
                                          size="small"
                                          options={boxSizeList}
                                          getOptionLabel={(option) => `${option.BOXTYPE} (${option.BOXSIZE})` || ''}
                                          renderOption={(props, option) => (
                                            <li {...props} key={option.BOXTYPEID}>
                                              {`${option.BOXTYPE} (${option.BOXSIZE})`}
                                            </li>
                                          )}
                                          value={
                                            box.BOXTYPEID === 0 || box.BOXTYPEID === '0'
                                              ? null
                                              : boxSizeList.find((item) => item.BOXTYPEID === box.BOXTYPEID) || null
                                          }
                                          // disabled={isDisabled}
                                          onChange={(event, value) => {
                                            setInitialValue(values);
                                            handleBoxSizeChange(index, 'BoxSize', value || {}, values);
                                          }}
                                          isOptionEqualToValue={(option, value) =>
                                            option.BOXTYPEID === value?.BOXTYPEID
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              required
                                              {...params}
                                              label="Box Size"
                                              name={`boxDetails[${index}].BoxSize`}
                                              error={Boolean(
                                                errors[`boxDetails[${index}].BoxSize`] &&
                                                  touched[`boxDetails[${index}].BoxSize`]
                                              )}
                                              helperText={
                                                touched[`boxDetails[${index}].BoxSize`] &&
                                                errors[`boxDetails[${index}].BoxSize`]
                                              }
                                              onBlur={handleBlur}
                                            />
                                          )}
                                        />
                                      )}
                                    </Grid>

                                    <Grid item md={2} xs={12}>
                                      <TextField
                                        size="small"
                                        fullWidth
                                        label="Length"
                                        type="number"
                                        //     type="text"
                                        // inputProps={{ inputMode: 'numeric' }}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        value={box.length}
                                        // disabled={isDisabled}
                                        disabled={box.BoxType !== 'Custom'}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const updatedBoxes = [...boxDetails];
                                          const newLength = parseFloat(e.target.value) || '';
                                          if (newLength > 0 || newLength === '') {
                                            updatedBoxes[index].length = newLength;
                                            const rawCubicWeight =
                                              box.dimensionType === 'CM'
                                                ? (Number(box.height) / 100) *
                                                  (Number(newLength) / 100) *
                                                  (Number(box.width) / 100)
                                                : Number(box.height) *
                                                  0.0254 *
                                                  (Number(newLength) * 0.0254) *
                                                  (Number(box.width) * 0.0254);
                                            updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                            setBoxDetails(updatedBoxes);
                                            GetNewShipperPrice(values.receiverCountry, updatedBoxes);
                                          }
                                        }}
                                        name={`boxDetails[${index}].length`}
                                        onBlur={handleBlur}
                                        error={Boolean(
                                          errors[`boxDetails[${index}].length`] &&
                                            touched[`boxDetails[${index}].length`]
                                        )}
                                        helperText={
                                          touched[`boxDetails[${index}].length`] &&
                                          errors[`boxDetails[${index}].length`]
                                        }
                                        required
                                      />
                                    </Grid>

                                    <Grid item md={2} xs={12}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        label="Width"
                                        type="number"
                                        //     type="text"
                                        // inputProps={{ inputMode: 'numeric' }}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        value={box.width}
                                        required
                                        // disabled={isDisabled}
                                        disabled={box.BoxType !== 'Custom'}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const updatedBoxes = [...boxDetails];
                                          const newWidth = parseFloat(e.target.value) || '';
                                          if (newWidth > 0 || newWidth === '') {
                                            updatedBoxes[index].width = newWidth;
                                            const rawCubicWeight =
                                              box.dimensionType === 'CM'
                                                ? (Number(box.height) / 100) *
                                                  (Number(box.length) / 100) *
                                                  (Number(newWidth) / 100)
                                                : Number(box.height) *
                                                  0.0254 *
                                                  (Number(box.length) * 0.0254) *
                                                  (Number(newWidth) * 0.0254);
                                            updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                            setBoxDetails(updatedBoxes);
                                            GetNewShipperPrice(values.receiverCountry, updatedBoxes);
                                          }
                                        }}
                                        name={`boxDetails[${index}].width`}
                                        onBlur={handleBlur}
                                        error={Boolean(
                                          errors[`boxDetails[${index}].width`] && touched[`boxDetails[${index}].width`]
                                        )}
                                        helperText={
                                          touched[`boxDetails[${index}].width`] && errors[`boxDetails[${index}].width`]
                                        }
                                      />
                                    </Grid>

                                    <Grid item md={2} xs={12}>
                                      <TextField
                                        fullWidth
                                        required
                                        size="small"
                                        label="Height"
                                        type="number"
                                        //     type="text"
                                        // inputProps={{ inputMode: 'numeric' }}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        value={box.height}
                                        // disabled={isDisabled}
                                        disabled={box.BoxType !== 'Custom'}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const updatedBoxes = [...boxDetails];
                                          const newHeight = parseFloat(e.target.value) || '';
                                          if (newHeight > 0 || newHeight === '') {
                                            updatedBoxes[index].height = newHeight;
                                            const rawCubicWeight =
                                              box.dimensionType === 'CM'
                                                ? (Number(newHeight) / 100) *
                                                  (Number(box.length) / 100) *
                                                  (Number(box.width) / 100)
                                                : Number(newHeight) *
                                                  0.0254 *
                                                  (Number(box.length) * 0.0254) *
                                                  (Number(box.width) * 0.0254);
                                            updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                            setBoxDetails(updatedBoxes);
                                            GetNewShipperPrice(values.receiverCountry, updatedBoxes);
                                          }
                                        }}
                                        name={`boxDetails[${index}].height`}
                                        onBlur={handleBlur}
                                        error={Boolean(
                                          errors[`boxDetails[${index}].height`] &&
                                            touched[`boxDetails[${index}].height`]
                                        )}
                                        helperText={
                                          touched[`boxDetails[${index}].height`] &&
                                          errors[`boxDetails[${index}].height`]
                                        }
                                      />
                                    </Grid>

                                    <Grid item md={3} xs={12}>
                                      <Autocomplete
                                        fullWidth
                                        size="small"
                                        options={DimensionType}
                                        disabled={box.BoxType !== 'Custom'}
                                        getOptionLabel={(option) => option.label || ''}
                                        renderOption={(props, option) => (
                                          <li {...props} key={option.value}>
                                            {option.label}
                                          </li>
                                        )}
                                        value={DimensionType.find((item) => item.value === box.dimensionType) || null}
                                        // disabled={isDisabled}
                                        onChange={(event, value) => {
                                          const updatedBoxes = [...boxDetails];
                                          updatedBoxes[index] = {
                                            ...updatedBoxes[index],
                                            dimensionType: value ? value.value : null,
                                          };
                                          const rawCubicWeight =
                                            value.value === 'CM'
                                              ? (Number(box.height) / 100) *
                                                (Number(box.length) / 100) *
                                                (Number(box.width) / 100)
                                              : Number(box.height) *
                                                0.0254 *
                                                (Number(box.length) * 0.0254) *
                                                (Number(box.width) * 0.0254);
                                          updatedBoxes[index].cubicWeight = parseFloat(rawCubicWeight.toFixed(2));
                                          setBoxDetails(updatedBoxes);
                                          GetNewShipperPrice(values.receiverCountry, updatedBoxes);
                                        }}
                                        isOptionEqualToValue={(option, value) => option.value === value?.value}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            required
                                            label="Dimension"
                                            name={`boxDetails[${index}].dimensionType`}
                                            onBlur={handleBlur}
                                            error={Boolean(
                                              errors[`boxDetails[${index}].dimensionType`] &&
                                                touched[`boxDetails[${index}].dimensionType`]
                                            )}
                                            helperText={
                                              touched[`boxDetails[${index}].dimensionType`] &&
                                              errors[`boxDetails[${index}].dimensionType`]
                                            }
                                          />
                                        )}
                                      />
                                    </Grid>

                                    <Grid item md={3} xs={12}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        label="CBM"
                                        required
                                        type="number"
                                        value={box.cubicWeight === 0 ? '' : box.cubicWeight}
                                        onWheel={(e) => e.target.blur()}
                                        disabled
                                        name={`boxDetails[${index}].cubicWeight`}
                                        onBlur={handleBlur}
                                        error={Boolean(
                                          errors[`boxDetails[${index}].cubicWeight`] &&
                                            touched[`boxDetails[${index}].cubicWeight`]
                                        )}
                                        helperText={
                                          touched[`boxDetails[${index}].cubicWeight`] &&
                                          errors[`boxDetails[${index}].cubicWeight`]
                                        }
                                      />
                                    </Grid>

                                    <Grid item md={3} xs={12}>
                                      <TextField
                                        fullWidth
                                        size="small"
                                        label="Gross Weight"
                                        required
                                        type="number"
                                        //     type="text"
                                        // inputProps={{ inputMode: 'numeric' }}
                                        onKeyDown={(e) => {
                                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                            e.preventDefault();
                                          }
                                        }}
                                        value={box.grossWeight}
                                        // disabled={isDisabled}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          const updatedBoxes = [...boxDetails];
                                          const newGrossWeight = parseFloat(e.target.value) || '';
                                          if (newGrossWeight > 0 || newGrossWeight === '') {
                                            updatedBoxes[index].grossWeight = newGrossWeight;
                                            setBoxDetails(updatedBoxes);
                                          }
                                        }}
                                        name={`boxDetails[${index}].grossWeight`}
                                        onBlur={handleBlur}
                                        error={Boolean(
                                          errors[`boxDetails[${index}].grossWeight`] &&
                                            touched[`boxDetails[${index}].grossWeight`]
                                        )}
                                        helperText={
                                          touched[`boxDetails[${index}].grossWeight`] &&
                                          errors[`boxDetails[${index}].grossWeight`]
                                        }
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Paper>
                            </Grid>
                          ))}

                        <Grid item md={12} xs={12}>
                          <Stack direction="row" justifyContent="center" sx={{ width: '100%' }} p={0} m={0}>
                            <Button
                              variant="contained"
                              color={'info'}
                              size="small"
                              sx={{ boxShadow: 1 }}
                              onClick={() => {
                                handleAddBox(setFieldValue, values);
                              }}
                              // disabled={isDisabled}
                              fullWidth
                            >
                              Add Another Box
                            </Button>
                          </Stack>
                        </Grid>

                        {/* <Grid item md={6} xs={12}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Collection Date"
                          type="date"
                          inputProps={{ max: '9999-12-31' }}
                          name="collectionDate"
                          InputLabelProps={{ shrink: true }}
                          onBlur={handleBlur}
                          error={touched.collectionDate && !!errors.collectionDate}
                          helperText={touched.collectionDate && errors.collectionDate ? errors.collectionDate : ''}
                          value={values.collectionDate}
                          onChange={handleChange}
                        />
                      </Grid> */}

                        {/* Terms and Conditions Checkbox */}
                        <Grid item xs={12}>
                          <Stack direction="column" alignItems="center" gap={2}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={values.acceptTerms}
                                  // onChange={handleChange}
                                  onChange={(e) => {
                                    if (!values.acceptTerms) {
                                      // Only open dialog if the box isn't already checked
                                      setTermsDialogOpen(true);
                                    }
                                    if (e.target.checked) {
                                      setTC(true);
                                    } else {
                                      setTC(false);
                                    }
                                    handleChange(e); // Formik's handler to update the checkbox state
                                  }}
                                  name="acceptTerms"
                                  color="primary"
                                  inputRef={(el) => {
                                    fieldRefs.current.acceptTerms = el;
                                  }}
                                />
                              }
                              label={
                                <span>
                                  I agree to the{' '}
                                  <Button
                                    variant="text"
                                    size="small"
                                    onClick={() => {
                                      setTermsDialogOpen(true);
                                    }}
                                    sx={{ textTransform: 'none', padding: 0, color: 'primary.main' }}
                                  >
                                    terms and conditions
                                  </Button>
                                </span>
                              }
                            />
                            {touched.acceptTerms && errors.acceptTerms && (
                              <Typography variant="caption" color="error">
                                {errors.acceptTerms}
                              </Typography>
                            )}
                          </Stack>
                        </Grid>
                      </>
                    )}
                  </Grid>

                  {bookingStarted && (
                    <div style={{ position: 'sticky', bottom: 0 }}>
                      <Stack
                        direction="row"
                        justifyContent="center"
                        gap={2}
                        sx={{
                          textAlign: 'center',
                          mt: 3,
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="center"
                          gap={2}
                          sx={{
                            backgroundColor: '#7ca3e94f',
                            padding: '10px',
                            borderRadius: '10px',
                            backdropFilter: 'blur(4px)',
                          }}
                        >
                          {headerData.IsCancel === 'N' && headerData.OrderRaised === 'N' && (
                            <>
                              {/* {sessionStorage.getItem('userRole') === 'Sales' && seOrderCancelReq === 'R' ? (
                                <Chip label="Processing" color="error" size="small" />
                              ) : ( */}
                              {isDraft ? (
                                <Button
                                  onClick={handleOpenDeleteDialogCargo}
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  sx={{ boxShadow: 1 }}
                                >
                                  Delete
                                </Button>
                              ) : (
                                <Button
                                  // onClick={
                                  //   sessionStorage.getItem('userRole') === 'Sales'
                                  //     ? handleOpenConfirmCancelReq
                                  //     : handleOpenConfirmCancel
                                  // }
                                  onClick={() => {
                                    const userRole = sessionStorage.getItem('userRole');
                                    if (userRole === 'Sales') {
                                      handleOpenConfirmCancelReq();
                                    } else if (userRole === 'Admin') {
                                      if (seOrderCancelReq === 'R') {
                                        handleOpenConfirmCancel();
                                      } else {
                                        handleOpenConfirmCancelReq();
                                      }
                                    }
                                  }}
                                  variant="contained"
                                  color="error"
                                  size="small"
                                  sx={{ boxShadow: 1 }}
                                  disabled={
                                    (sessionStorage.getItem('userRole') === 'Sales' && seOrderCancelReq === 'R') ||
                                    (sessionStorage.getItem('userRole') === 'Sales' && otherBranchBool)
                                  }
                                >
                                  {sessionStorage.getItem('userRole') === 'Sales' ? 'Cancel Request' : 'Cancel Booking'}
                                </Button>
                              )}
                              {/* )} */}

                              {/* <Button
                                onClick={() => {
                                  setOpen(!open);
                                  setEditID('');
                                  setInitialValue({ ...resetStates });
                                  setDialogOpenState(false);
                                  getAllData();
                                }}
                                variant="contained"
                                color="warning"
                                size="small"
                                sx={{ boxShadow: 1 }}
                              >
                                Shift Order
                              </Button> */}
                              <Button
                                onClick={() => handleValidationFlow(values, validateForm)}
                                // onClick={() => {
                                //   if (!validateBoxGoodsDetails(boxDetails)) {
                                //     return; // Stop further processing if validation fails
                                //   }

                                //   if (Number(values.senderCountry) !== Number(senderSecondaryCountryId) && sameAsSender === true) {
                                //     setOpenConfirmDialog1(true);
                                //     const selectedCountry = countryList.find((d) => Number(d.CountryId) === Number(values.senderCountry));
                                //     const customerCountry = countryList.find((d) => Number(d.CountryId) === Number(senderSecondaryCountryId));
                                //     setChangeContent(`There is a mismatch between the sender's country as selected (${selectedCountry.CountryName})
                                //           and the one recorded in the customer record (${customerCountry.CountryName}). Please review and update the country as necessary.`);
                                //     return;
                                //   }

                                //   setSubmitConfirmation(true);
                                // }}
                                disabled={
                                  isSubmitting ||
                                  (sessionStorage.getItem('userRole') === 'Sales' && seOrderCancelReq === 'R') ||
                                  (sessionStorage.getItem('userRole') === 'Sales' && otherBranchBool)
                                }
                                variant="contained"
                                color="success"
                                size="small"
                                sx={{ boxShadow: 1 }}
                              >
                                {headerData.APPROVAL === 'N' && !isDraft ? 'Approve' : 'Update'}
                              </Button>
                              {/* Delete Confirmation Dialog */}
                              <Dialog
                                open={openDeleteDialogCargo}
                                onClose={handleCloseDeleteDialogCargo}
                                fullWidth
                                maxWidth="xs"
                              >
                                <DialogTitle sx={{ textAlign: 'center' }}>Are you sure you want to delete?</DialogTitle>
                                <DialogContent>
                                  <Typography>This action will permanently delete the cargo order.</Typography>
                                </DialogContent>
                                <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: 2 }}>
                                  <Button variant="contained" onClick={handleCloseDeleteDialogCargo} color="primary">
                                    Cancel
                                  </Button>
                                  <Button variant="contained" onClick={deleteCargoOrder} color="error">
                                    Delete
                                  </Button>
                                </DialogActions>
                              </Dialog>
                              {isDraft && (
                                <Button
                                  onClick={() => {
                                    submitCargoOrder({ ...initialValue, ...values }, 'Y');
                                  }}
                                  variant="contained"
                                  color="inherit"
                                  size="small"
                                  sx={{ boxShadow: 1 }}
                                >
                                  Save As Draft
                                </Button>
                              )}
                            </>
                          )}
                          {sessionStorage.getItem('userRole') !== 'Sales' && IsCancel === 'Y' && (
                            <Button
                              onClick={handleOpenConfirmRevertReq}
                              variant="contained"
                              color="error"
                              size="small"
                              sx={{ boxShadow: 1 }}
                              // disabled={sessionStorage.getItem('userRole') === 'Sales' && seOrderCancelReq === 'R'}
                            >
                              Revert
                            </Button>
                          )}
                          <Button
                            onClick={() => {
                              setOpen(!open);
                              setEditID('');
                              setInitialValue({ ...resetStates });
                              setDialogOpenState(false);
                              closeSnackBar();
                              getAllData();
                            }}
                            variant="contained"
                            color={headerData.APPROVAL === 'N' ? 'info' : 'warning'}
                            size="small"
                            sx={{ boxShadow: 1 }}
                          >
                            Close
                          </Button>
                          {/* Confirmation Dialog */}
                          <Dialog open={submitConfirmation} onClose={() => setSubmitConfirmation(false)}>
                            <DialogTitle>Confirm Submission</DialogTitle>
                            <DialogContent>
                              <p>Are you sure you want to submit?</p>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={() => setSubmitConfirmation(false)} color="warning" variant="contained">
                                Cancel
                              </Button>
                              <Button
                                onClick={() => {
                                  if (!validateBoxNewGoodsDetails(boxDetails)) {
                                    return; // Stop further processing if validation fails
                                  }

                                  if (values.receiverCountry.length === 0) {
                                    setreceiverCountryErr(true);
                                  } else {
                                    setreceiverCountryErr(false);
                                  }
                                  if (values.senderCountry.length === 0) {
                                    setsenderCountryErr(true);
                                  } else {
                                    setsenderCountryErr(false);
                                  }
                                  submitForm();
                                  setSubmitConfirmation(false);
                                }}
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                                size="success"
                                sx={{ boxShadow: 1 }}
                              >
                                Confirm
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </Stack>
                      </Stack>
                    </div>
                  )}

                  {/* Confirmation Dialog for Deletion */}
                  <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                      <Typography>Are you sure you want to delete this box?</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseConfirmDialog} color="primary">
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          showLoading();
                          setInitialValue(values);
                          const updatedBoxDetails = [...boxDetails];
                          updatedBoxDetails.splice(boxToDelete, 1);
                          const reIndexedBoxDetails = updatedBoxDetails.map((box, index) => ({
                            ...box,
                            boxNo: index + 1,
                          }));

                          setBoxDetails(reIndexedBoxDetails);
                          // GetShipperPrice(reIndexedBoxDetails);
                          // GetShipperPrice1(null, null, null, reIndexedBoxDetails);
                          GetNewShipperPrice(values.receiverCountry, reIndexedBoxDetails);
                          setTimeout(async () => {
                            await new Promise((resolve) => {
                              setFieldValue('NofoBoxes', reIndexedBoxDetails.length, () => resolve());
                            });
                          }, 1000);
                          hideLoading();
                          handleCloseConfirmDialog();
                        }}
                        color="error"
                      >
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Confirmation Dialog for Cancellation */}
                  <Dialog open={openConfirmCancel} onClose={handleCloseConfirmClose}>
                    <DialogTitle>Confirm Booking Cancellation</DialogTitle>
                    <DialogContent>
                      <Typography>Are you sure you want to cancel this booking?</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseConfirmClose} color="warning" variant="contained">
                        No
                      </Button>
                      <Button onClick={cancelOrder} color="error" variant="contained">
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Confirmation Dialog for Change Country */}
                  <Dialog open={openConfirmDialog1} onClose={handleCloseConfirmDialog1}>
                    <DialogTitle>Change Country</DialogTitle>
                    <DialogContent>
                      <Typography>{changeContent}</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseConfirmDialog1} color="warning">
                        Close
                      </Button>
                      {/* <Button onClick={() => changeCountry(setFieldValue)} color="error">
                      Change
                    </Button> */}
                    </DialogActions>
                  </Dialog>

                  {/* Dialog for Preview */}
                  <Dialog open={dialogOpen} fullWidth maxWidth="sm">
                    <DialogTitle>Goods Preview</DialogTitle>
                    <DialogContent>
                      {selectedGoods && (
                        <Grid container spacing={1} p={1}>
                          <Grid item md={12} xs={12}>
                            <Stack direction="column" spacing={2}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                border={1}
                                borderRadius={1}
                                borderColor="#e0e0e0"
                                p={1}
                                justifyContent="center"
                              >
                                <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                  <Box title="delete image">
                                    <label htmlFor={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}>
                                      <img
                                        src={
                                          /\.(jpg|jpeg|png|gif)$/i.test(selectedGoods?.goods?.image)
                                            ? `${axios.defaults.commonImageURL}/Cargo/${selectedGoods?.goods?.image}`
                                            : imagePreviews[`${selectedGoods?.index}-${selectedGoods?.goodsIndex}`] ||
                                              imagepreview
                                        }
                                        alt="Preview"
                                        className={classes.chooseFileButton}
                                        style={{
                                          maxWidth: '100px',
                                          maxHeight: '100px',
                                          minWidth: '100px',
                                          minHeight: '100px',
                                          objectFit: 'contain',
                                          cursor: 'pointer',
                                          position: 'relative',
                                        }}
                                      />
                                      <IconButton
                                        id={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}
                                        style={{
                                          position: 'absolute',
                                          top: '70px',
                                          right: '50px',
                                          background: 'white',
                                          zIndex: 10,
                                        }}
                                        onClick={() => {
                                          handleDeleteImage();
                                          handleCloseDialog();
                                        }}
                                      >
                                        <DeleteForeverIcon color="error" />
                                      </IconButton>
                                      <input
                                        className={classes.fileInput}
                                        id={`fileInput-${selectedGoods?.index}-${selectedGoods?.goodsIndex}`}
                                        type="file"
                                        accept="image/jpeg"
                                        name="IDcardFile"
                                        onChange={(event) => {
                                          handleFileChange(
                                            event,
                                            'image',
                                            selectedGoods?.index,
                                            selectedGoods?.goodsIndex
                                          );
                                        }}
                                        style={{ display: 'none' }}
                                      />
                                    </label>
                                  </Box>
                                </Stack>
                              </Stack>
                            </Stack>
                          </Grid>

                          <Grid item md={12} xs={12}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Goods Name{' '}
                              <Typography variant="h6" color="#009688">
                                {selectedGoods?.goods?.goodsName}
                              </Typography>
                            </Typography>
                          </Grid>

                          <Grid item md={6} xs={12}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              UOM{' '}
                              <Typography variant="h6" color="#009688">
                                {uomList.find((uom) => Number(uom.UOM_Id) === Number(selectedGoods?.goods?.UOM_Id))
                                  ?.UOM_Description || ''}
                              </Typography>
                            </Typography>
                          </Grid>

                          <Grid item md={6} xs={12}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Quantity{' '}
                              <Typography variant="h6" color="#009688">
                                {selectedGoods?.goods?.quantity}
                              </Typography>
                            </Typography>
                          </Grid>

                          <Grid item md={6} xs={12}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Rate{' '}
                              <Typography variant="h6" color="#009688">
                                {selectedGoods?.goods?.rate}
                              </Typography>
                            </Typography>
                          </Grid>
                          <Grid item md={6} xs={12}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Value{' '}
                              <Typography variant="h6" color="#009688">
                                {selectedGoods?.goods?.value}
                              </Typography>
                            </Typography>
                          </Grid>
                          {sessionStorage.getItem('userRole') !== 'Sales' && (
                            <Grid item md={12} xs={12}>
                              <TextField
                                fullWidth
                                margin="normal"
                                label="HSN Code"
                                value={hsnCode}
                                disabled={selectedGoods?.goods?.APPROVAL !== 'N'}
                                onChange={(e) => setHsnCode(e.target.value)}
                                size="small"
                              />
                            </Grid>
                          )}
                        </Grid>
                      )}
                      <Stack justifyContent={'center'} direction={'row'} spacing={2} alignItems={'center'}>
                        {' '}
                        <Button onClick={handleCloseDialog} color="warning" variant="contained" size="small">
                          Close
                        </Button>
                        {selectedGoods?.goods?.APPROVAL !== 'R' && (
                          <Button
                            onClick={() => {
                              handleGoodsChange(selectedGoods?.index, selectedGoods?.goodsIndex, 'APPROVAL', 'R');
                              if (sessionStorage.getItem('userRole') === 'Admin') {
                                UpdateNewGoods(selectedGoods);
                              }
                              handleCloseDialog();
                            }}
                            color="error"
                            variant="contained"
                            size="small"
                          >
                            Reject
                          </Button>
                        )}
                        {sessionStorage.getItem('userRole') !== 'Sales' && (
                          <>
                            {selectedGoods?.goods?.APPROVAL !== 'Y' && (
                              <Button
                                onClick={() => {
                                  handleApprove(selectedGoods?.index, selectedGoods?.goodsIndex);
                                }}
                                color="success"
                                variant="contained"
                                size="small"
                              >
                                {selectedGoods?.goods.APPROVAL === 'R' ? 'Approve Again' : 'Approve'}
                              </Button>
                            )}
                          </>
                        )}
                      </Stack>
                    </DialogContent>
                  </Dialog>

                  {/* Add New Item */}
                  <Dialog open={dialogOpen1} fullWidth maxWidth="sm">
                    <DialogTitle>Create New Item</DialogTitle>
                    <DialogContent>
                      <Grid container spacing={1} p={1}>
                        <Grid item md={12} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            {/* Goods Description{' '} */}
                            <TextField
                              fullWidth
                              size="small"
                              label="Goods Description"
                              type="text"
                              name="GoodsName"
                              value={goodsdescription}
                              onChange={(e) => {
                                setgoodsdescription(e.target.value);
                              }}
                              required
                            />
                            {goodsdescriptionErr && (
                              <span style={{ color: 'red' }}>Please enter the goods description</span>
                            )}
                          </Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            {/* Rate{' '} */}
                            <TextField
                              fullWidth
                              size="small"
                              label="Rate"
                              type="number"
                              name="Rate"
                              value={rate}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) => {
                                const newRate = parseFloat(e.target.value) || '';
                                if (newRate > 0 || newRate === '') {
                                  setrate(e.target.value);
                                }
                              }}
                            />
                          </Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <Typography variant="subtitle2" color="GrayText" pr={1}>
                            {/* HSN Code{' '} */}
                            <TextField
                              fullWidth
                              size="small"
                              label="HSN Code"
                              type="text"
                              name="HSN"
                              value={hsnCodes}
                              onChange={(e) => {
                                sethsnCodes(e.target.value);
                              }}
                            />
                          </Typography>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={active}
                                onChange={(e) => {
                                  setactive(e.target.checked);
                                }}
                                name="activeCheckbox"
                                color="primary"
                              />
                            }
                            label="Active"
                          />
                        </Grid>
                      </Grid>

                      <Stack justifyContent={'center'} direction={'row'} spacing={2} alignItems={'center'}>
                        {' '}
                        <Button onClick={handleCloseDialog1} color="warning" variant="contained" size="small">
                          Close
                        </Button>
                        <Button
                          onClick={() => {
                            InsertGoodsMst();
                          }}
                          color="success"
                          variant="contained"
                          size="small"
                        >
                          {'Add'}
                        </Button>
                      </Stack>
                    </DialogContent>
                  </Dialog>

                  {/*  Confirmation Dialog for Cancel Request */}
                  {/* <Dialog open={opencancelreq} onClose={handleCloseCancelReq}>
                    <DialogTitle>Confirm Cancel Request</DialogTitle>
                    <DialogContent>
                      <Typography>Are you sure you want to raise the cancel request?</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseCancelReq} color="warning" variant="contained">
                        No
                      </Button>
                      <Button onClick={SEOrderCancelReq} color="error" variant="contained">
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog> */}
                  <Dialog
                    open={opencancelreq}
                    PaperProps={{
                      style: {
                        borderRadius: '12px',
                        padding: '10px',
                      },
                    }}
                  >
                    <DialogTitle sx={{ textAlign: 'center' }}>{`${
                      sessionStorage.getItem('userRole') === 'Sales'
                        ? 'Confirm Cancel Request'
                        : 'Confirm Booking Cancellation'
                    }`}</DialogTitle>
                    <DialogContent
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          textAlign: 'center',
                          color: '#555',
                        }}
                      >
                        {`${
                          sessionStorage.getItem('userRole') === 'Sales'
                            ? 'Before you request to cancel the shipment, could you let us know the reason? Are you sure you want to proceed?'
                            : 'Before cancel the shipment, could you please provide a reason?'
                        }
                        `}
                      </Typography>
                      <TextField
                        fullWidth
                        size="small"
                        label="Reason for Cancellation"
                        multiline
                        rows={4}
                        placeholder="Please provide a reason for cancellation..."
                        value={reason}
                        onChange={handleReasonChange}
                        InputProps={{
                          style: {
                            borderRadius: '8px',
                          },
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#ccc',
                            },
                            '&:hover fieldset': {
                              borderColor: '#aaa',
                            },
                          },
                        }}
                        error={!!error}
                        helperText={error}
                      />
                    </DialogContent>
                    <DialogActions
                      sx={{
                        justifyContent: 'center',
                        gap: '16px',
                        padding: '16px',
                      }}
                    >
                      <Button onClick={handleCloseCancelReq} variant="contained" color="warning">
                        No, Keep Order
                      </Button>
                      <Button
                        onClick={() =>
                          sessionStorage.getItem('userRole') === 'Sales' ? SEOrderCancelReq() : cancelOrder()
                        }
                        variant="contained"
                        color="error"
                      >
                        {sessionStorage.getItem('userRole') === 'Sales'
                          ? 'Yes, Request Cancel Order'
                          : 'Yes, Cancel Order'}
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Revert Order Dialog  */}
                  <Dialog open={openRevertReq} onClose={handleCloseRevertReq}>
                    <DialogTitle>Confirm Revert Request</DialogTitle>
                    <DialogContent>
                      <Typography>Are you sure you want to revert the order?</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseRevertReq} color="warning" variant="contained">
                        No
                      </Button>
                      <Button onClick={RevertOrder} color="error" variant="contained">
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>

                  {/* Terms and Conditions Dialog */}
                  <Dialog open={termsDialogOpen} maxWidth="md" fullWidth>
                    <DialogTitle>Terms and Conditions</DialogTitle>
                    <DialogContent
                      ref={contentRef}
                      dividers
                      style={{ maxHeight: '500px', overflowY: 'auto' }}
                      onScroll={handleScroll}
                    >
                      <TermsAndCondition />
                    </DialogContent>
                    <DialogActions>
                      {/* <Button
                      onClick={() => {
                        setFieldValue("acceptTerms", false);
                        setTermsDialogOpen(false)
                      }} variant="outlined" color="secondary">
                      Decline
                    </Button> */}
                      <Button
                        onClick={() => {
                          setFieldValue('acceptTerms', true);
                          setTermsDialogOpen(false);
                        }}
                        variant="contained"
                        color="primary"
                        disabled={!isScrolledToBottom}
                      >
                        Accept
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
                    <DialogTitle>Image Preview</DialogTitle>
                    <DialogContent>
                      <img
                        src={
                          previewTarget === 'sender'
                            ? senderImagePreview || imagepreview
                            : previewTarget === 'receiver'
                            ? receiverImagePreview || imagepreview
                            : imagePreview || imagepreview
                        }
                        alt="Preview"
                        style={{
                          maxWidth: '100%',
                          maxHeight: '400px',
                          objectFit: 'contain',
                        }}
                      />
                    </DialogContent>
                    <DialogActions>
                      <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ width: '100%' }}
                      >
                        <Stack direction="row" spacing={1}>
                          <Button
                            onClick={handleOpenConfirmDialogDelete}
                            color="error"
                            variant="outlined"
                            size="small"
                            startIcon={<DeleteOutlineIcon />}
                          >
                            Delete
                          </Button>

                          {/* Download Button */}
                          <Button
                            onClick={() => {
                              // Determine which image to download
                              let imageUrl = '';
                              let fileName = '';

                              if (previewTarget === 'sender') {
                                imageUrl = senderImagePreview;
                                fileName = `ID_card_${values.IdCardNo || 'unknown'}.jpg`;
                              } else if (previewTarget === 'receiver') {
                                imageUrl = receiverImagePreview;
                                fileName = `ID_card_${values.RecIdCardNo || 'unknown'}.jpg`;
                              }

                              // Download the image
                              if (imageUrl && imageUrl !== imagepreview) {
                                const link = document.createElement('a');
                                link.href = imageUrl;
                                link.download = fileName;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                              } else {
                                openSnackBar('No image available to download', 'warning');
                              }
                            }}
                            color="primary"
                            variant="contained"
                            size="small"
                            startIcon={<FileDownloadIcon />}
                          >
                            Download
                          </Button>
                        </Stack>

                        <Button
                          onClick={handleCloseDialogPreview}
                          color="primary"
                          startIcon={<CloseIcon />}
                          variant="outlined"
                          size="small"
                        >
                          Close
                        </Button>
                      </Stack>
                    </DialogActions>
                  </Dialog>
                  <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                    <DialogTitle>Confirm Deletion</DialogTitle>
                    <DialogContent>
                      <Typography>Are you sure you want to delete this image?</Typography>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                        Cancel
                      </Button>
                      <Button
                        onClick={() => {
                          if (previewTarget === 'sender') {
                            setSenderImageFile(null);
                            setSenderImagePreview('');
                            setFieldValue('IdCardNo', '');
                          } else if (previewTarget === 'receiver') {
                            setReceiverImageFile(null);
                            setReceiverImagePreview('');
                            setFieldValue('RecIdCardNo', '');
                          } else {
                            setSelectedImageFile(null);
                          }
                          setOpenDialogPreview(false);
                          handleCloseDialogPreview();
                          handleCloseConfirmDialogDelete();
                        }}
                        color="error"
                      >
                        Delete
                      </Button>
                    </DialogActions>
                  </Dialog>
                  {/* Shipper Price Dialog */}
                  {/* {cardToggle && shipperPriceData.length > 0 && shipperPriceData[0].weight > 0 && (
                    <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 999 }}>
                      <Paper
                        elevation={3}
                        sx={{
                          width: '260px',
                          borderRadius: '16px',
                          backgroundColor: '#1a1a2e',
                          color: 'white',
                          padding: 3,
                          position: 'relative',
                          textAlign: 'center',
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{
                            mb: 2,
                          }}
                        >
                          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontWeight: 500 }}>
                            {`${getCountryName(values.senderCountry)} - ${getCountryName(
                              values.receiverCountry
                            )} approximately`}{' '}
                          </Typography>
                          <IconButton
                            aria-label="close"
                            onClick={() => setCardToggle(false)}
                            sx={{
                              color: 'white',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.4)',
                              },
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </Stack>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          sx={{
                            padding: '8px 0',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                            mb: 2,
                          }}
                        >
                          <Typography variant="body1" sx={{ color: 'white' }}>
                            CBM
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'white' }}>
                            {`${shipperPriceData[0].weight || 0}`}
                          </Typography>
                        </Stack>
                        <Stack direction="row" justifyContent="space-between" sx={{ padding: '8px 0' }}>
                          <Typography variant="body1" sx={{ color: 'white' }}>
                            Price
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'white' }}>
                            {shipperPriceData[0].actualRate || 0}
                          </Typography>
                        </Stack>
                      </Paper>
                    </div>
                  )} */}

                  {/* {cardToggle && (
                    <div style={{ position: 'fixed', bottom: 12, right: 12, zIndex: 999 }}>
                      <Paper
                        elevation={3}
                        sx={{
                          width: '300px',
                          borderRadius: '16px',
                          backgroundColor: '#1a1a2e',
                          color: 'white',
                          padding: 2,
                          position: 'relative',
                          textAlign: 'center',
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{
                            mb: 1,
                          }}
                        >
                          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontWeight: 500 }}>
                            {`${getCountryName(values.senderCountry)} - ${getCountryName(
                              values.receiverCountry
                            )} approximately`}{' '}
                          </Typography>
                          <IconButton
                            aria-label="close"
                            onClick={() => setCardToggle(false)}
                            sx={{
                              color: 'white',
                              backgroundColor: 'rgba(255, 255, 255, 0.2)',
                              '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.4)',
                              },
                            }}
                            size="small"
                          >
                            <CloseIcon />
                          </IconButton>
                        </Stack>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          sx={{
                            padding: '8px 0',
                            borderBottom: '1px solid rgba(255, 255, 255, 0.2)',

                          }}
                        >
                          <Typography variant="body1" sx={{ color: 'white' }}>
                            CBM
                          </Typography>
                        </Stack>
                        <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                          {boxDetails
                            .filter(data => Number(data.cubicWeight) > 0 && Number(data.ActRate) > 0)
                            .map((data, index) => (
                              <Stack
                                key={index}
                                direction="row"
                                justifyContent="space-between"
                                sx={{
                                  padding: '8px 0',
                                  borderBottom:
                                    index < boxDetails.length - 1 ? '1px solid rgba(255, 255, 255, 0.2)' : 'none',
                                  mx: 1,
                                }}
                              >
                                <Typography variant="body2" sx={{ color: 'white', letterSpacing: '1px' }}>
                                  {`Box ${data.boxNo} with ${data.cubicWeight}m = ${data.actualRate || 0}`}
                                </Typography>
                              </Stack>
                            ))}
                        </div>
                      </Paper>
                    </div>
                  )} */}

                  {/* Shipper Price Dialog */}
                  {cardToggle && shipperPriceData?.output?.length > 0 && (
                    <div style={{ position: 'fixed', bottom: 16, right: 16, zIndex: 999 }}>
                      <Paper
                        elevation={isMinimized ? 2 : 6}
                        sx={{
                          width: isMinimized ? 180 : 280,
                          borderRadius: '16px',
                          background: 'linear-gradient(145deg, #1a1a2e 0%, #16213e 100%)',
                          color: '#fff',
                          position: 'relative',
                          textAlign: 'center',
                          transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                          overflow: 'hidden',
                          border: '1px solid rgba(255,255,255,0.08)',
                          boxShadow: isMinimized ? '0 4px 20px rgba(0,0,0,0.3)' : '0 12px 40px rgba(0,0,0,0.4)',
                          backdropFilter: 'blur(20px)',
                        }}
                      >
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{
                            px: isMinimized ? 1.5 : 2,
                            py: isMinimized ? 1.2 : 1.5,
                            borderBottom: isMinimized ? 'none' : '1px solid rgba(255,255,255,0.06)',
                            transition: 'all 0.3s ease',
                          }}
                        >
                          <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
                            <Box
                              sx={{
                                width: 8,
                                height: 8,
                                borderRadius: '50%',
                                bgcolor: '#4ade80',
                                boxShadow: '0 0 8px rgba(74,222,128,0.6)',
                                animation: 'pulse 2s infinite',
                              }}
                            />
                            <Typography
                              sx={{
                                color: 'rgba(255,255,255,0.85)',
                                fontWeight: 600,
                                fontSize: isMinimized ? '0.75rem' : '0.8rem',
                                letterSpacing: '0.3px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {isMinimized ? `Price Options (${shipperPriceData.output.length})` : 'Price Details'}
                            </Typography>
                          </Stack>

                          <Stack direction="row" spacing={0.5}>
                            <IconButton
                              aria-label="minimize"
                              onClick={() => setIsMinimized(!isMinimized)}
                              sx={{
                                color: 'rgba(255,255,255,0.8)',
                                bgcolor: 'rgba(255,255,255,0.06)',
                                width: 26,
                                height: 26,
                                '&:hover': { bgcolor: 'rgba(255,255,255,0.15)' },
                                transition: 'all 0.3s ease',
                                transform: isMinimized ? 'rotate(180deg)' : 'rotate(0deg)',
                              }}
                              size="small"
                            >
                              <ExpandLessIcon sx={{ fontSize: '1rem' }} />
                            </IconButton>

                            <IconButton
                              aria-label="close"
                              onClick={() => setCardToggle(false)}
                              sx={{
                                color: 'rgba(255,255,255,0.8)',
                                bgcolor: 'rgba(255,255,255,0.06)',
                                width: 26,
                                height: 26,
                                '&:hover': { bgcolor: 'rgba(239,68,68,0.3)' },
                                transition: 'all 0.2s ease',
                              }}
                              size="small"
                            >
                              <CloseIcon sx={{ fontSize: '1rem' }} />
                            </IconButton>
                          </Stack>
                        </Stack>

                        <Box
                          sx={{
                            maxHeight: isMinimized ? 0 : 380,
                            opacity: isMinimized ? 0 : 1,
                            overflow: 'hidden',
                            transition: 'all 0.45s cubic-bezier(0.4, 0, 0.2, 1)',
                          }}
                        >
                          <Box
                            sx={{
                              px: 2,
                              py: 1.2,
                              bgcolor: 'rgba(255,255,255,0.03)',
                              borderBottom: '1px solid rgba(255,255,255,0.06)',
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '0.7rem',
                                color: 'rgba(255,255,255,0.5)',
                                textTransform: 'uppercase',
                                letterSpacing: '0.8px',
                                fontWeight: 600,
                                mb: 0.3,
                              }}
                            >
                              Route
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: '0.8rem',
                                fontWeight: 500,
                                color: 'rgba(255,255,255,0.9)',
                                lineHeight: 1.3,
                              }}
                            >
                              {getCountryName(values.senderCountry)} → {getCountryName(values.receiverCountry)}
                            </Typography>
                            <Typography sx={{ fontSize: '0.7rem', color: 'rgba(255,255,255,0.45)', mt: 0.2 }}>
                              {`CBM - ${shipperPriceData.totalCBM || 0}`}
                            </Typography>
                          </Box>

                          <Box
                            sx={{
                              maxHeight: 220,
                              overflowY: 'auto',
                              px: 1.5,
                              py: 1,
                              '&::-webkit-scrollbar': { width: '4px' },
                              '&::-webkit-scrollbar-track': {
                                background: 'rgba(255,255,255,0.03)',
                                borderRadius: '4px',
                              },
                              '&::-webkit-scrollbar-thumb': {
                                background: 'rgba(255,255,255,0.15)',
                                borderRadius: '4px',
                                '&:hover': { background: 'rgba(255,255,255,0.25)' },
                              },
                            }}
                          >
                            {shipperPriceData.output.map((item, index) => {
                              const isSelected = values.shipper === item.ShipperLinerName;

                              return (
                                <Box
                                  key={index}
                                  onClick={() => {
                                    setFieldValue('shipper', item.ShipperLinerName || '');
                                    setShipperId(item.ShipperLinerId);
                                    setFieldTouched('shipper', true);
                                    setTimeout(() => setIsMinimized(true), 800);
                                  }}
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    px: 1.5,
                                    py: 1,
                                    mb: index < shipperPriceData.output.length - 1 ? 0.5 : 0,
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    bgcolor: isSelected ? 'rgba(74,222,128,0.12)' : 'rgba(255,255,255,0.03)',
                                    border: isSelected ? '1px solid rgba(74,222,128,0.3)' : '1px solid transparent',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                      bgcolor: isSelected ? 'rgba(74,222,128,0.18)' : 'rgba(255,255,255,0.07)',
                                      transform: 'translateX(2px)',
                                    },
                                  }}
                                >
                                  <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0, flex: 1 }}>
                                    <Box
                                      sx={{
                                        width: 18,
                                        height: 18,
                                        borderRadius: '50%',
                                        border: isSelected ? '2px solid #4ade80' : '2px solid rgba(255,255,255,0.25)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        transition: 'all 0.2s ease',
                                      }}
                                    >
                                      {isSelected && (
                                        <Box
                                          sx={{
                                            width: 8,
                                            height: 8,
                                            borderRadius: '50%',
                                            bgcolor: '#4ade80',
                                            boxShadow: '0 0 6px rgba(74,222,128,0.5)',
                                          }}
                                        />
                                      )}
                                    </Box>

                                    <Box sx={{ minWidth: 0 }}>
                                      <Typography
                                        sx={{
                                          fontSize: '0.78rem',
                                          fontWeight: isSelected ? 600 : 400,
                                          color: isSelected ? '#fff' : 'rgba(255,255,255,0.8)',
                                          lineHeight: 1.2,
                                          whiteSpace: 'normal',
                                          overflowWrap: 'anywhere',
                                        }}
                                      >
                                        {item.ShipperLinerName || ''}
                                      </Typography>
                                      {Number(item.TransitTime) > 0 && (
                                        <Typography
                                          sx={{
                                            fontSize: '0.65rem',
                                            color: 'rgba(255,255,255,0.4)',
                                            lineHeight: 1.3,
                                            mt: 0.2,
                                          }}
                                        >
                                          ~{item.TransitTime} days transit
                                        </Typography>
                                      )}
                                    </Box>
                                  </Stack>

                                  <Typography
                                    sx={{
                                      fontSize: isSelected ? '0.9rem' : '0.82rem',
                                      fontWeight: isSelected ? 700 : 500,
                                      color: isSelected ? '#4ade80' : 'rgba(255,255,255,0.75)',
                                      ml: 1,
                                      flexShrink: 0,
                                      transition: 'all 0.2s ease',
                                    }}
                                  >
                                    {item.Symbol}
                                    {numeral(item.totalNetRate).format('0,0.00')}
                                  </Typography>
                                </Box>
                              );
                            })}
                          </Box>
                        </Box>

                        <style>
                          {`@keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }`}
                        </style>
                      </Paper>
                    </div>
                  )}
                </Form>
              )}
            </Formik>
          </Stack>
        </Container>
      </Container>
    </>
  );
};

export default PreviewForCargoOrderApproval;
